export const DictionaryPhotoshop_es_ES = [
    {
        id: 1,
        label: 'Photoshop > Acerca de Photoshop...',
        placement: 'MenuBar',
        name: 'Acerca de Photoshop...',
    },
    {
        id: 10,
        label: 'Archivo > Nuevo...',
        placement: 'MenuBar',
        name: 'Nuevo...',
    },
    {
        id: 20,
        label: 'Archivo > Abrir...',
        placement: 'MenuBar',
        name: 'Abrir...',
    },
    {
        id: 22,
        label: 'Archivo > Abrir como objeto inteligente...',
        placement: 'MenuBar',
        name: 'Abrir como objeto inteligente...',
    },
    {
        id: 30,
        label: 'Archivo > Guardar',
        placement: 'MenuBar',
        name: 'Guardar',
    },
    {
        id: 31,
        label: 'Archivo > Cerrar',
        placement: 'MenuBar',
        name: 'Cerrar',
    },
    {
        id: 32,
        label: 'Archivo > Guardar como...',
        placement: 'MenuBar',
        name: 'Guardar como...',
    },
    {
        id: 33,
        label: 'Archivo > Guardar una copia...',
        placement: 'MenuBar',
        name: 'Guardar una copia...',
    },
    {
        id: 34,
        label: 'Archivo > Volver',
        placement: 'MenuBar',
        name: 'Volver',
    },
    {
        id: 36,
        label: 'Photoshop > Salir de Photoshop',
        placement: 'MenuBar',
        name: 'Salir de Photoshop',
    },
    {
        id: 37,
        label: 'Archivo > Cerrar todo',
        placement: 'MenuBar',
        name: 'Cerrar todo',
    },
    {
        id: 46,
        label: 'Archivo > Cerrar otros',
        placement: 'MenuBar',
        name: 'Cerrar otros',
    },
    {
        id: 101,
        label: 'Edición > Deshacer',
        placement: 'MenuBar',
        name: 'Deshacer',
    },
    {
        id: 103,
        label: 'Edición > Cortar',
        placement: 'MenuBar',
        name: 'Cortar',
    },
    {
        id: 104,
        label: 'Edición > Copiar',
        placement: 'MenuBar',
        name: 'Copiar',
    },
    {
        id: 105,
        label: 'Edición > Pegar',
        placement: 'MenuBar',
        name: 'Pegar',
    },
    {
        id: 106,
        label: 'Edición > Borrar',
        placement: 'MenuBar',
        name: 'Borrar',
    },
    {
        id: 132,
        label: 'Edición > Rehacer',
        placement: 'MenuBar',
        name: 'Rehacer',
    },
    {
        id: 133,
        label: 'Edición > Alternar último estado',
        placement: 'MenuBar',
        name: 'Alternar último estado',
    },
    {
        id: 177,
        label: 'Archivo > Imprimir una copia',
        placement: 'MenuBar',
        name: 'Imprimir una copia',
    },
    {
        id: 1001,
        label: 'Ventana > Organizar > Nueva ventana',
        placement: 'MenuBar',
        name: 'Nueva ventana',
    },
    {
        id: 1002,
        label: 'Vista > Reglas',
        placement: 'MenuBar',
        name: 'Reglas',
    },
    {
        id: 1004,
        label: 'Vista > Aumentar',
        placement: 'MenuBar',
        name: 'Aumentar',
    },
    {
        id: 1005,
        label: 'Vista > Reducir',
        placement: 'MenuBar',
        name: 'Reducir',
    },
    {
        id: 1006,
        label: 'Imagen > Modo > Mapa de bits',
        placement: 'MenuBar',
        name: 'Mapa de bits',
    },
    {
        id: 1007,
        label: 'Imagen > Modo > Escala de grises',
        placement: 'MenuBar',
        name: 'Escala de grises',
    },
    {
        id: 1008,
        label: 'Imagen > Modo > Duotono',
        placement: 'MenuBar',
        name: 'Duotono',
    },
    {
        id: 1009,
        label: 'Imagen > Modo > Color indexado',
        placement: 'MenuBar',
        name: 'Color indexado',
    },
    {
        id: 1010,
        label: 'Imagen > Modo > Color RGB',
        placement: 'MenuBar',
        name: 'Color RGB',
    },
    {
        id: 1011,
        label: 'Imagen > Modo > Color CMYK',
        placement: 'MenuBar',
        name: 'Color CMYK',
    },
    {
        id: 1014,
        label: 'Imagen > Modo > Multicanal',
        placement: 'MenuBar',
        name: 'Multicanal',
    },
    {
        id: 1016,
        label: 'Selección > Deseleccionar',
        placement: 'MenuBar',
        name: 'Deseleccionar',
    },
    {
        id: 1017,
        label: 'Selección > Todo',
        placement: 'MenuBar',
        name: 'Todo',
    },
    {
        id: 1018,
        label: 'Selección > Invertir',
        placement: 'MenuBar',
        name: 'Invertir',
    },
    {
        id: 1019,
        label: 'Filtro > Último filtro',
        placement: 'MenuBar',
        name: 'Último filtro',
    },
    {
        id: 1021,
        label: 'Ventana > Canales',
        placement: 'MenuBar',
        name: 'Canales',
    },
    {
        id: 1025,
        label: 'Ventana > Ajustes del pincel',
        placement: 'MenuBar',
        name: 'Ajustes del pincel',
    },
    {
        id: 1029,
        label: 'Edición > Definir valor de pincel...',
        placement: 'MenuBar',
        name: 'Definir valor de pincel...',
    },
    {
        id: 1030,
        label: 'Imagen > Tamaño de imagen...',
        placement: 'MenuBar',
        name: 'Tamaño de imagen...',
    },
    {
        id: 1031,
        label: 'Imagen > Tamaño de lienzo...',
        placement: 'MenuBar',
        name: 'Tamaño de lienzo...',
    },
    {
        id: 1032,
        label: 'Archivo > Colocar elemento incrustado…',
        placement: 'MenuBar',
        name: 'Colocar elemento incrustado…',
    },
    {
        id: 1033,
        label: 'Selección > Extender',
        placement: 'MenuBar',
        name: 'Extender',
    },
    {
        id: 1034,
        label: 'Selección > Similar',
        placement: 'MenuBar',
        name: 'Similar',
    },
    {
        id: 1035,
        label: 'Selección > Modificar > Borde...',
        placement: 'MenuBar',
        name: 'Borde...',
    },
    {
        id: 1036,
        label: 'Selección > Modificar > Desvanecer...',
        placement: 'MenuBar',
        name: 'Desvanecer...',
    },
    {
        id: 1037,
        label: 'Capa > Halos > Eliminar halos...',
        placement: 'MenuBar',
        name: 'Eliminar halos...',
    },
    {
        id: 1038,
        label: 'Edición > Definir motivo...',
        placement: 'MenuBar',
        name: 'Definir motivo...',
    },
    {
        id: 1040,
        label: 'Edición > Pegado especial > Pegar dentro',
        placement: 'MenuBar',
        name: 'Pegar dentro',
    },
    {
        id: 1042,
        label: 'Edición > Rellenar...',
        placement: 'MenuBar',
        name: 'Rellenar...',
    },
    {
        id: 1043,
        label: 'Edición > Contornear...',
        placement: 'MenuBar',
        name: 'Contornear...',
    },
    {
        id: 1044,
        label: 'Imagen > Recortar',
        placement: 'MenuBar',
        name: 'Recortar',
    },
    {
        id: 1045,
        label: 'Imagen > Modo > Tabla de colores...',
        placement: 'MenuBar',
        name: 'Tabla de colores...',
    },
    {
        id: 1046,
        label: 'Ventana > Color',
        placement: 'MenuBar',
        name: 'Color',
    },
    {
        id: 1052,
        label: 'Imagen > Modo > Color Lab',
        placement: 'MenuBar',
        name: 'Color Lab',
    },
    {
        id: 1055,
        label: 'Ventana > Información',
        placement: 'MenuBar',
        name: 'Información',
    },
    {
        id: 1058,
        label: 'Ventana > Origen de clonación',
        placement: 'MenuBar',
        name: 'Origen de clonación',
    },
    {
        id: 1065,
        label: 'Ventana > Trazados',
        placement: 'MenuBar',
        name: 'Trazados',
    },
    {
        id: 1080,
        label: 'Imagen > Cortar...',
        placement: 'MenuBar',
        name: 'Cortar...',
    },
    {
        id: 1081,
        label: 'Imagen > Descubrir todas',
        placement: 'MenuBar',
        name: 'Descubrir todas',
    },
    {
        id: 1093,
        label: 'Imagen > Reventar...',
        placement: 'MenuBar',
        name: 'Reventar...',
    },
    {
        id: 1098,
        label: 'Ventana > Capas',
        placement: 'MenuBar',
        name: 'Capas',
    },
    {
        id: 1099,
        label: 'Capa > Nueva > Capa...',
        placement: 'MenuBar',
        name: 'Capa...',
    },
    {
        id: 1100,
        label: 'Capa > Eliminar > Capa',
        placement: 'MenuBar',
        name: 'Capa',
    },
    {
        id: 1103,
        label: 'Capa > Opciones de contenido de capa...',
        placement: 'MenuBar',
        name: 'Opciones de contenido de capa...',
    },
    {
        id: 1105,
        label: 'Vista > Colores de prueba',
        placement: 'MenuBar',
        name: 'Colores de prueba',
    },
    {
        id: 1106,
        label: 'Vista > Aviso de gama',
        placement: 'MenuBar',
        name: 'Aviso de gama',
    },
    {
        id: 1107,
        label: 'Edición > Copiar combinado',
        placement: 'MenuBar',
        name: 'Copiar combinado',
    },
    {
        id: 1108,
        label: 'Selección > Modificar > Redondear…',
        placement: 'MenuBar',
        name: 'Redondear…',
    },
    {
        id: 1109,
        label: 'Selección > Modificar > Expandir...',
        placement: 'MenuBar',
        name: 'Expandir...',
    },
    {
        id: 1110,
        label: 'Selección > Modificar > Contraer...',
        placement: 'MenuBar',
        name: 'Contraer...',
    },
    {
        id: 1111,
        label: 'Ventana > Opciones',
        placement: 'MenuBar',
        name: 'Opciones',
    },
    {
        id: 1112,
        label: 'Vista > Corrección de proporción de píxeles',
        placement: 'MenuBar',
        name: 'Corrección de proporción de píxeles',
    },
    {
        id: 1114,
        label: 'Capa > Ocultar capas',
        placement: 'MenuBar',
        name: 'Ocultar capas',
    },
    {
        id: 1115,
        label: 'Selección > Seleccionar y aplicar máscara...',
        placement: 'MenuBar',
        name: 'Seleccionar y aplicar máscara...',
    },
    {
        id: 1119,
        label: 'Ventana > Muestras',
        placement: 'MenuBar',
        name: 'Muestras',
    },
    {
        id: 1134,
        label: 'Imagen > Duplicar...',
        placement: 'MenuBar',
        name: 'Duplicar...',
    },
    {
        id: 1135,
        label: 'Capa > Duplicar capa...',
        placement: 'MenuBar',
        name: 'Duplicar capa...',
    },
    {
        id: 1137,
        label: 'Archivo > Información de archivo...',
        placement: 'MenuBar',
        name: 'Información de archivo...',
    },
    {
        id: 1139,
        label: 'Capa > Combinar visibles',
        placement: 'MenuBar',
        name: 'Combinar visibles',
    },
    {
        id: 1141,
        label: 'Capa > Acoplar imagen',
        placement: 'MenuBar',
        name: 'Acoplar imagen',
    },
    {
        id: 1152,
        label: 'Selección > Rango de color...',
        placement: 'MenuBar',
        name: 'Rango de color...',
    },
    {
        id: 1153,
        label: 'Imagen > Aplicar imagen...',
        placement: 'MenuBar',
        name: 'Aplicar imagen...',
    },
    {
        id: 1154,
        label: 'Edición > Transición...',
        placement: 'MenuBar',
        name: 'Transición...',
    },
    {
        id: 1156,
        label: 'Capa > Máscara de capa > Ocultar todo',
        placement: 'MenuBar',
        name: 'Ocultar todo',
    },
    {
        id: 1157,
        label: 'Capa > Máscara de capa > Descubrir todo',
        placement: 'MenuBar',
        name: 'Descubrir todo',
    },
    {
        id: 1158,
        label: 'Capa > Máscara de capa > Descubrir selección',
        placement: 'MenuBar',
        name: 'Descubrir selección',
    },
    {
        id: 1159,
        label: 'Capa > Máscara de capa > Habilitar',
        placement: 'MenuBar',
        name: 'Habilitar',
    },
    {
        id: 1161,
        label: 'Imagen > Modo > 8 Bits/canal',
        placement: 'MenuBar',
        name: '8 Bits/canal',
    },
    {
        id: 1162,
        label: 'Imagen > Modo > 16 Bits/canal',
        placement: 'MenuBar',
        name: '16 Bits/canal',
    },
    {
        id: 1163,
        label: 'Ventana > Navegador',
        placement: 'MenuBar',
        name: 'Navegador',
    },
    {
        id: 1166,
        label: 'Capa > Combinar capas',
        placement: 'MenuBar',
        name: 'Combinar capas',
    },
    {
        id: 1167,
        label: 'Ventana > Composiciones de capas',
        placement: 'MenuBar',
        name: 'Composiciones de capas',
    },
    {
        id: 1168,
        label: 'Capa > Máscara de capa > Ocultar selección',
        placement: 'MenuBar',
        name: 'Ocultar selección',
    },
    {
        id: 1169,
        label: 'Archivo > Automatizar > Crear droplet...',
        placement: 'MenuBar',
        name: 'Crear droplet...',
    },
    {
        id: 1170,
        label: 'Ventana > Acciones',
        placement: 'MenuBar',
        name: 'Acciones',
    },
    {
        id: 1180,
        label: 'Archivo > Automatizar > Lote...',
        placement: 'MenuBar',
        name: 'Lote...',
    },
    {
        id: 1188,
        label: 'Ventana > Línea de tiempo',
        placement: 'MenuBar',
        name: 'Línea de tiempo',
    },
    {
        id: 1190,
        label: 'Vista > 100%',
        placement: 'MenuBar',
        name: '100%',
    },
    {
        id: 1191,
        label: 'Vista > Tamaño de impresión',
        placement: 'MenuBar',
        name: 'Tamaño de impresión',
    },
    {
        id: 1192,
        label: 'Vista > Encajar en pantalla',
        placement: 'MenuBar',
        name: 'Encajar en pantalla',
    },
    {
        id: 1194,
        label: 'Ventana > Herramientas',
        placement: 'MenuBar',
        name: 'Herramientas',
    },
    {
        id: 1195,
        label: 'Vista > Encajar mesa de trabajo en pantalla',
        placement: 'MenuBar',
        name: 'Encajar mesa de trabajo en pantalla',
    },
    {
        id: 1199,
        label: 'Ventana > Historia',
        placement: 'MenuBar',
        name: 'Historia',
    },
    {
        id: 1200,
        label: 'Selección > Cargar selección...',
        placement: 'MenuBar',
        name: 'Cargar selección...',
    },
    {
        id: 1202,
        label: 'Vista > Proporción de píxeles > Proporción de píxeles personalizada...',
        placement: 'MenuBar',
        name: 'Proporción de píxeles personalizada...',
    },
    {
        id: 1203,
        label: 'Vista > Proporción de píxeles > Eliminar proporción de píxeles...',
        placement: 'MenuBar',
        name: 'Eliminar proporción de píxeles...',
    },
    {
        id: 1204,
        label: 'Vista > Proporción de píxeles > Restaurar proporciones de píxeles...',
        placement: 'MenuBar',
        name: 'Restaurar proporciones de píxeles...',
    },
    {
        id: 1205,
        label: 'Vista > Proporción de píxeles > Cuadrado',
        placement: 'MenuBar',
        name: 'Cuadrado',
    },
    {
        id: 1206,
        label: 'Imagen > Modo > 32 Bits/canal',
        placement: 'MenuBar',
        name: '32 Bits/canal',
    },
    {
        id: 1211,
        label: 'Edición > Ajustes preestablecidos > Migrar ajustes preestablecidos',
        placement: 'MenuBar',
        name: 'Migrar ajustes preestablecidos',
    },
    {
        id: 1212,
        label: 'Edición > Asignar perfil...',
        placement: 'MenuBar',
        name: 'Asignar perfil...',
    },
    {
        id: 1213,
        label: 'Edición > Convertir en perfil...',
        placement: 'MenuBar',
        name: 'Convertir en perfil...',
    },
    {
        id: 1214,
        label: 'Edición > Ajustes preestablecidos > Gestor de ajustes preestablecidos...',
        placement: 'MenuBar',
        name: 'Gestor de ajustes preestablecidos...',
    },
    {
        id: 1215,
        label: 'Edición > Ajustes preestablecidos de Adobe PDF...',
        placement: 'MenuBar',
        name: 'Ajustes preestablecidos de Adobe PDF...',
    },
    {
        id: 1217,
        label: 'Vista > Tamaño real',
        placement: 'MenuBar',
        name: 'Tamaño real',
    },
    {
        id: 1223,
        label: 'Texto > Orientación > Horizontal',
        placement: 'MenuBar',
        name: 'Horizontal',
    },
    {
        id: 1224,
        label: 'Texto > Orientación > Vertical',
        placement: 'MenuBar',
        name: 'Vertical',
    },
    {
        id: 1228,
        label: 'Texto > Crear trazado de trabajo',
        placement: 'MenuBar',
        name: 'Crear trazado de trabajo',
    },
    {
        id: 1229,
        label: 'Texto > Convertir en forma',
        placement: 'MenuBar',
        name: 'Convertir en forma',
    },
    {
        id: 1231,
        label: 'Capa > Alinear > Bordes superiores',
        placement: 'MenuBar',
        name: 'Bordes superiores',
    },
    {
        id: 1232,
        label: 'Capa > Alinear > Bordes inferiores',
        placement: 'MenuBar',
        name: 'Bordes inferiores',
    },
    {
        id: 1233,
        label: 'Capa > Alinear > Centros verticales',
        placement: 'MenuBar',
        name: 'Centros verticales',
    },
    {
        id: 1234,
        label: 'Capa > Alinear > Bordes izquierdos',
        placement: 'MenuBar',
        name: 'Bordes izquierdos',
    },
    {
        id: 1235,
        label: 'Capa > Alinear > Bordes derechos',
        placement: 'MenuBar',
        name: 'Bordes derechos',
    },
    {
        id: 1236,
        label: 'Capa > Alinear > Centros horizontales',
        placement: 'MenuBar',
        name: 'Centros horizontales',
    },
    {
        id: 1237,
        label: 'Edición > Alinear capas automáticamente...',
        placement: 'MenuBar',
        name: 'Alinear capas automáticamente...',
    },
    {
        id: 1238,
        label: 'Edición > Fusionar capas automáticamente...',
        placement: 'MenuBar',
        name: 'Fusionar capas automáticamente...',
    },
    {
        id: 1239,
        label: 'Capa > Distribuir > Verticalmente',
        placement: 'MenuBar',
        name: 'Verticalmente',
    },
    {
        id: 1241,
        label: 'Capa > Distribuir > Bordes superiores',
        placement: 'MenuBar',
        name: 'Bordes superiores',
    },
    {
        id: 1242,
        label: 'Capa > Distribuir > Bordes inferiores',
        placement: 'MenuBar',
        name: 'Bordes inferiores',
    },
    {
        id: 1243,
        label: 'Capa > Distribuir > Centros verticales',
        placement: 'MenuBar',
        name: 'Centros verticales',
    },
    {
        id: 1245,
        label: 'Capa > Distribuir > Bordes izquierdos',
        placement: 'MenuBar',
        name: 'Bordes izquierdos',
    },
    {
        id: 1246,
        label: 'Capa > Distribuir > Bordes derechos',
        placement: 'MenuBar',
        name: 'Bordes derechos',
    },
    {
        id: 1247,
        label: 'Capa > Distribuir > Centros horizontales',
        placement: 'MenuBar',
        name: 'Centros horizontales',
    },
    {
        id: 1249,
        label: 'Capa > Distribuir > Horizontalmente',
        placement: 'MenuBar',
        name: 'Horizontalmente',
    },
    {
        id: 1281,
        label: 'Selección > Guardar selección...',
        placement: 'MenuBar',
        name: 'Guardar selección...',
    },
    {
        id: 1284,
        label: 'Vista > Voltear horizontal',
        placement: 'MenuBar',
        name: 'Voltear horizontal',
    },
    {
        id: 1285,
        label: 'Vista > Vista preliminar de motivo',
        placement: 'MenuBar',
        name: 'Vista preliminar de motivo',
    },
    {
        id: 1292,
        label: 'Capa > Máscara de capa > De transparencia',
        placement: 'MenuBar',
        name: 'De transparencia',
    },
    {
        id: 1295,
        label: 'Capa > Halos > Descontaminación de color...',
        placement: 'MenuBar',
        name: 'Descontaminación de color...',
    },
    {
        id: 1297,
        label: 'Edición > Pegado especial > Pegar en contexto',
        placement: 'MenuBar',
        name: 'Pegar en contexto',
    },
    {
        id: 1299,
        label: 'Vista > 200%',
        placement: 'MenuBar',
        name: '200%',
    },
    {
        id: 1301,
        label: 'Capa > Estilo de capa > Sombra paralela...',
        placement: 'MenuBar',
        name: 'Sombra paralela...',
    },
    {
        id: 1302,
        label: 'Capa > Estilo de capa > Sombra interior...',
        placement: 'MenuBar',
        name: 'Sombra interior...',
    },
    {
        id: 1303,
        label: 'Capa > Estilo de capa > Resplandor exterior...',
        placement: 'MenuBar',
        name: 'Resplandor exterior...',
    },
    {
        id: 1304,
        label: 'Capa > Estilo de capa > Resplandor interior...',
        placement: 'MenuBar',
        name: 'Resplandor interior...',
    },
    {
        id: 1305,
        label: 'Capa > Estilo de capa > Bisel y relieve...',
        placement: 'MenuBar',
        name: 'Bisel y relieve...',
    },
    {
        id: 1306,
        label: 'Capa > Estilo de capa > Ocultar todos los efectos',
        placement: 'MenuBar',
        name: 'Ocultar todos los efectos',
    },
    {
        id: 1307,
        label: 'Capa > Estilo de capa > Luz global...',
        placement: 'MenuBar',
        name: 'Luz global...',
    },
    {
        id: 1308,
        label: 'Capa > Estilo de capa > Crear capas',
        placement: 'MenuBar',
        name: 'Crear capas',
    },
    {
        id: 1312,
        label: 'Capa > Estilo de capa > Satinado...',
        placement: 'MenuBar',
        name: 'Satinado...',
    },
    {
        id: 1313,
        label: 'Capa > Estilo de capa > Trazo...',
        placement: 'MenuBar',
        name: 'Trazo...',
    },
    {
        id: 1314,
        label: 'Capa > Estilo de capa > Copiar estilo de capa',
        placement: 'MenuBar',
        name: 'Copiar estilo de capa',
    },
    {
        id: 1315,
        label: 'Capa > Estilo de capa > Pegar estilo de capa',
        placement: 'MenuBar',
        name: 'Pegar estilo de capa',
    },
    {
        id: 1327,
        label: 'Capa > Estilo de capa > Cambiar escala de efectos…',
        placement: 'MenuBar',
        name: 'Cambiar escala de efectos…',
    },
    {
        id: 1331,
        label: 'Capa > Estilo de capa > Opciones de fusión...',
        placement: 'MenuBar',
        name: 'Opciones de fusión...',
    },
    {
        id: 1335,
        label: 'Capa > Estilo de capa > Superposición de colores...',
        placement: 'MenuBar',
        name: 'Superposición de colores...',
    },
    {
        id: 1336,
        label: 'Capa > Estilo de capa > Superposición de degradado...',
        placement: 'MenuBar',
        name: 'Superposición de degradado...',
    },
    {
        id: 1337,
        label: 'Capa > Estilo de capa > Superposición de motivo...',
        placement: 'MenuBar',
        name: 'Superposición de motivo...',
    },
    {
        id: 1339,
        label: 'Capa > Estilo de capa > Borrar estilo de capa',
        placement: 'MenuBar',
        name: 'Borrar estilo de capa',
    },
    {
        id: 1355,
        label: 'Ventana > Notas',
        placement: 'MenuBar',
        name: 'Notas',
    },
    {
        id: 1382,
        label: 'Ventana > Histograma',
        placement: 'MenuBar',
        name: 'Histograma',
    },
    {
        id: 1396,
        label: 'Ventana > Pinceles',
        placement: 'MenuBar',
        name: 'Pinceles',
    },
    {
        id: 1429,
        label: 'Plugins > Panel de plugins',
        placement: 'MenuBar',
        name: 'Panel de plugins',
    },
    {
        id: 1430,
        label: 'Plugins > Buscar plugins...',
        placement: 'MenuBar',
        name: 'Buscar plugins...',
    },
    {
        id: 1431,
        label: 'Plugins > Gestionar plugins...',
        placement: 'MenuBar',
        name: 'Gestionar plugins...',
    },
    {
        id: 1460,
        label: 'Selección > Área de enfoque...',
        placement: 'MenuBar',
        name: 'Área de enfoque...',
    },
    {
        id: 1461,
        label: 'Selección > Sujeto',
        placement: 'MenuBar',
        name: 'Sujeto',
    },
    {
        id: 1462,
        label: 'Selección > Cielo',
        placement: 'MenuBar',
        name: 'Cielo',
    },
    {
        id: 1502,
        label: 'Archivo > Importar > Imágenes desde el dispositivo...',
        placement: 'MenuBar',
        name: 'Imágenes desde el dispositivo...',
    },
    {
        id: 1503,
        label: 'Archivo > Importar desde iPhone o iPad',
        placement: 'MenuBar',
        name: 'Importar desde iPhone o iPad',
    },
    {
        id: 1510,
        label: 'Edición > Relleno según el contenido...',
        placement: 'MenuBar',
        name: 'Relleno según el contenido...',
    },
    {
        id: 1520,
        label: 'Archivo > Buscar en Bridge...',
        placement: 'MenuBar',
        name: 'Buscar en Bridge...',
    },
    {
        id: 1522,
        label: 'Texto > Más de Adobe Fonts...',
        placement: 'MenuBar',
        name: 'Más de Adobe Fonts...',
    },
    {
        id: 1530,
        label: 'Archivo > Cerrar e ir a Bridge...',
        placement: 'MenuBar',
        name: 'Cerrar e ir a Bridge...',
    },
    {
        id: 1613,
        label: 'Edición > Conexiones remotas...',
        placement: 'MenuBar',
        name: 'Conexiones remotas...',
    },
    {
        id: 1676,
        label: 'Archivo > Secuencias de comandos > Explorar...',
        placement: 'MenuBar',
        name: 'Explorar...',
    },
    {
        id: 1695,
        label: 'Archivo > Exportar > Guardar para Web...',
        placement: 'MenuBar',
        name: 'Guardar para Web...',
    },
    {
        id: 1696,
        label: 'Archivo > Automatizar > Presentación en PDF...',
        placement: 'MenuBar',
        name: 'Presentación en PDF...',
    },
    {
        id: 1701,
        label: 'Imagen > Ajustes > Invertir',
        placement: 'MenuBar',
        name: 'Invertir',
    },
    {
        id: 1702,
        label: 'Imagen > Ajustes > Ecualizar',
        placement: 'MenuBar',
        name: 'Ecualizar',
    },
    {
        id: 1703,
        label: 'Imagen > Ajustes > Umbral...',
        placement: 'MenuBar',
        name: 'Umbral...',
    },
    {
        id: 1704,
        label: 'Imagen > Ajustes > Posterizar...',
        placement: 'MenuBar',
        name: 'Posterizar...',
    },
    {
        id: 1750,
        label: 'Edición > Relleno generativo...',
        placement: 'MenuBar',
        name: 'Relleno generativo...',
    },
    {
        id: 1771,
        label: 'Edición > Generar imagen...',
        placement: 'MenuBar',
        name: 'Generar imagen...',
    },
    {
        id: 1776,
        label: 'Imagen > Aumento de escala generativa...',
        placement: 'MenuBar',
        name: 'Aumento de escala generativa...',
    },
    {
        id: 1777,
        label: 'Filtro > Quitar ruido con IA…',
        placement: 'MenuBar',
        name: 'Quitar ruido con IA…',
    },
    {
        id: 1778,
        label: 'Filtro > Enfoque con IA…',
        placement: 'MenuBar',
        name: 'Enfoque con IA…',
    },
    {
        id: 1801,
        label: 'Imagen > Ajustes > Niveles...',
        placement: 'MenuBar',
        name: 'Niveles...',
    },
    {
        id: 1802,
        label: 'Imagen > Ajustes > Curvas...',
        placement: 'MenuBar',
        name: 'Curvas...',
    },
    {
        id: 1803,
        label: 'Imagen > Ajustes > Brillo/contraste...',
        placement: 'MenuBar',
        name: 'Brillo/contraste...',
    },
    {
        id: 1804,
        label: 'Imagen > Ajustes > Equilibrio de color...',
        placement: 'MenuBar',
        name: 'Equilibrio de color...',
    },
    {
        id: 1805,
        label: 'Imagen > Ajustes > Tono/saturación...',
        placement: 'MenuBar',
        name: 'Tono/saturación...',
    },
    {
        id: 1806,
        label: 'Imagen > Ajustes > Reemplazar color...',
        placement: 'MenuBar',
        name: 'Reemplazar color...',
    },
    {
        id: 1807,
        label: 'Imagen > Ajustes > Corrección selectiva...',
        placement: 'MenuBar',
        name: 'Corrección selectiva...',
    },
    {
        id: 1808,
        label: 'Imagen > Tono automático',
        placement: 'MenuBar',
        name: 'Tono automático',
    },
    {
        id: 1809,
        label: 'Imagen > Ajustes > Desaturar',
        placement: 'MenuBar',
        name: 'Desaturar',
    },
    {
        id: 1810,
        label: 'Imagen > Contraste automático',
        placement: 'MenuBar',
        name: 'Contraste automático',
    },
    {
        id: 1817,
        label: 'Imagen > Color automático',
        placement: 'MenuBar',
        name: 'Color automático',
    },
    {
        id: 1822,
        label: 'Imagen > Ajustes > Igualar color...',
        placement: 'MenuBar',
        name: 'Igualar color...',
    },
    {
        id: 1824,
        label: 'Imagen > Ajustes > Blanco y negro...',
        placement: 'MenuBar',
        name: 'Blanco y negro...',
    },
    {
        id: 1827,
        label: 'Imagen > Ajustes > Intensidad...',
        placement: 'MenuBar',
        name: 'Intensidad...',
    },
    {
        id: 1900,
        label: 'Imagen > Calcular...',
        placement: 'MenuBar',
        name: 'Calcular...',
    },
    {
        id: 1942,
        label: 'Capa > Nueva > Fondo',
        placement: 'MenuBar',
        name: 'Fondo',
    },
    {
        id: 1943,
        label: 'Selección > Volver a seleccionar',
        placement: 'MenuBar',
        name: 'Volver a seleccionar',
    },
    {
        id: 1953,
        label: 'Capa > Máscara vectorial > Ocultar todo',
        placement: 'MenuBar',
        name: 'Ocultar todo',
    },
    {
        id: 1954,
        label: 'Capa > Máscara vectorial > Descubrir todo',
        placement: 'MenuBar',
        name: 'Descubrir todo',
    },
    {
        id: 1955,
        label: 'Capa > Máscara vectorial > Trazado actual',
        placement: 'MenuBar',
        name: 'Trazado actual',
    },
    {
        id: 1956,
        label: 'Capa > Máscara vectorial > Eliminar',
        placement: 'MenuBar',
        name: 'Eliminar',
    },
    {
        id: 1957,
        label: 'Capa > Rasterizar > Máscara vectorial',
        placement: 'MenuBar',
        name: 'Máscara vectorial',
    },
    {
        id: 1959,
        label: 'Capa > Máscara vectorial > Habilitar',
        placement: 'MenuBar',
        name: 'Habilitar',
    },
    {
        id: 1971,
        label: 'Selección > Transformar selección',
        placement: 'MenuBar',
        name: 'Transformar selección',
    },
    {
        id: 2101,
        label: 'Archivo > Imprimir...',
        placement: 'MenuBar',
        name: 'Imprimir...',
    },
    {
        id: 2103,
        label: 'Archivo > Abrir recientes > Borrar lista de archivos recientes',
        placement: 'MenuBar',
        name: 'Borrar lista de archivos recientes',
    },
    {
        id: 2109,
        label: 'Capa > Máscara vectorial > Enlazar',
        placement: 'MenuBar',
        name: 'Enlazar',
    },
    {
        id: 2201,
        label: 'Edición > Transformar > Escala',
        placement: 'MenuBar',
        name: 'Escala',
    },
    {
        id: 2202,
        label: 'Edición > Transformar > Sesgar',
        placement: 'MenuBar',
        name: 'Sesgar',
    },
    {
        id: 2203,
        label: 'Edición > Transformar > Perspectiva',
        placement: 'MenuBar',
        name: 'Perspectiva',
    },
    {
        id: 2204,
        label: 'Edición > Transformar > Distorsionar',
        placement: 'MenuBar',
        name: 'Distorsionar',
    },
    {
        id: 2205,
        label: 'Edición > Transformar > Rotar',
        placement: 'MenuBar',
        name: 'Rotar',
    },
    {
        id: 2207,
        label: 'Edición > Transformación libre',
        placement: 'MenuBar',
        name: 'Transformación libre',
    },
    {
        id: 2208,
        label: 'Edición > Transformar > Rotar 180°',
        placement: 'MenuBar',
        name: 'Rotar 180°',
    },
    {
        id: 2209,
        label: 'Edición > Transformar > Rotar 90° a la derecha',
        placement: 'MenuBar',
        name: 'Rotar 90° a la derecha',
    },
    {
        id: 2210,
        label: 'Edición > Transformar > Rotar 90° a la izquierda',
        placement: 'MenuBar',
        name: 'Rotar 90° a la izquierda',
    },
    {
        id: 2211,
        label: 'Edición > Transformar > Voltear horizontal',
        placement: 'MenuBar',
        name: 'Voltear horizontal',
    },
    {
        id: 2212,
        label: 'Edición > Transformar > Voltear vertical',
        placement: 'MenuBar',
        name: 'Voltear vertical',
    },
    {
        id: 2217,
        label: 'Edición > Transformar > Otra vez',
        placement: 'MenuBar',
        name: 'Otra vez',
    },
    {
        id: 2218,
        label: 'Texto > Deformar texto...',
        placement: 'MenuBar',
        name: 'Deformar texto...',
    },
    {
        id: 2219,
        label: 'Edición > Transformar > Deformar',
        placement: 'MenuBar',
        name: 'Deformar',
    },
    {
        id: 2220,
        label: 'Edición > Escala según el contenido',
        placement: 'MenuBar',
        name: 'Escala según el contenido',
    },
    {
        id: 2221,
        label: 'Edición > Deformación de posición libre',
        placement: 'MenuBar',
        name: 'Deformación de posición libre',
    },
    {
        id: 2224,
        label: 'Filtro > Galería de efectos Desenfocar > Desenfocar iris...',
        placement: 'MenuBar',
        name: 'Desenfocar iris...',
    },
    {
        id: 2225,
        label: 'Filtro > Galería de efectos Desenfocar > Desenfoque de campo...',
        placement: 'MenuBar',
        name: 'Desenfoque de campo...',
    },
    {
        id: 2226,
        label: 'Filtro > Galería de efectos Desenfocar > Cambio de inclinación...',
        placement: 'MenuBar',
        name: 'Cambio de inclinación...',
    },
    {
        id: 2227,
        label: 'Filtro > Galería de efectos Desenfocar > Desenfoque de trazado...',
        placement: 'MenuBar',
        name: 'Desenfoque de trazado...',
    },
    {
        id: 2229,
        label: 'Filtro > Galería de efectos Desenfocar > Desenfoque de giro…',
        placement: 'MenuBar',
        name: 'Desenfoque de giro…',
    },
    {
        id: 2231,
        label: 'Filtro > Interpretar > Llama…',
        placement: 'MenuBar',
        name: 'Llama…',
    },
    {
        id: 2232,
        label: 'Filtro > Interpretar > Marco de fotografía...',
        placement: 'MenuBar',
        name: 'Marco de fotografía...',
    },
    {
        id: 2233,
        label: 'Filtro > Interpretar > Árbol...',
        placement: 'MenuBar',
        name: 'Árbol...',
    },
    {
        id: 2250,
        label: 'Edición > Transformar > Dividir deformación horizontalmente',
        placement: 'MenuBar',
        name: 'Dividir deformación horizontalmente',
    },
    {
        id: 2251,
        label: 'Edición > Transformar > Dividir deformación verticalmente',
        placement: 'MenuBar',
        name: 'Dividir deformación verticalmente',
    },
    {
        id: 2252,
        label: 'Edición > Transformar > Dividir deformación transversalmente',
        placement: 'MenuBar',
        name: 'Dividir deformación transversalmente',
    },
    {
        id: 2253,
        label: 'Edición > Transformar > Quitar división de deformación',
        placement: 'MenuBar',
        name: 'Quitar división de deformación',
    },
    {
        id: 2254,
        label: 'Edición > Transformar > Conmutar guías',
        placement: 'MenuBar',
        name: 'Conmutar guías',
    },
    {
        id: 2255,
        label: 'Edición > Transformar > Convertir punto de ancla de deformación',
        placement: 'MenuBar',
        name: 'Convertir punto de ancla de deformación',
    },
    {
        id: 2260,
        label: 'Edición > Sustitución de cielo...',
        placement: 'MenuBar',
        name: 'Sustitución de cielo...',
    },
    {
        id: 2304,
        label: 'Photoshop > Preferencias > Rendimiento...',
        placement: 'MenuBar',
        name: 'Rendimiento...',
    },
    {
        id: 2311,
        label: 'Photoshop > Preferencias > Generales...',
        placement: 'MenuBar',
        name: 'Generales...',
    },
    {
        id: 2312,
        label: 'Photoshop > Preferencias > Cursores...',
        placement: 'MenuBar',
        name: 'Cursores...',
    },
    {
        id: 2313,
        label: 'Photoshop > Preferencias > Transparencia y gama...',
        placement: 'MenuBar',
        name: 'Transparencia y gama...',
    },
    {
        id: 2314,
        label: 'Photoshop > Preferencias > Unidades y reglas...',
        placement: 'MenuBar',
        name: 'Unidades y reglas...',
    },
    {
        id: 2315,
        label: 'Photoshop > Preferencias > Guías, cuadros y sectores...',
        placement: 'MenuBar',
        name: 'Guías, cuadros y sectores...',
    },
    {
        id: 2316,
        label: 'Photoshop > Preferencias > Plugins...',
        placement: 'MenuBar',
        name: 'Plugins...',
    },
    {
        id: 2317,
        label: 'Photoshop > Preferencias > Administración de archivos...',
        placement: 'MenuBar',
        name: 'Administración de archivos...',
    },
    {
        id: 2322,
        label: 'Photoshop > Preferencias > Texto...',
        placement: 'MenuBar',
        name: 'Texto...',
    },
    {
        id: 2323,
        label: 'Photoshop > Preferencias > Interfaz...',
        placement: 'MenuBar',
        name: 'Interfaz...',
    },
    {
        id: 2324,
        label: 'Photoshop > Preferencias > RAW de cámara...',
        placement: 'MenuBar',
        name: 'RAW de cámara...',
    },
    {
        id: 2327,
        label: 'Photoshop > Preferencias > Previsualizaciones de tecnología...',
        placement: 'MenuBar',
        name: 'Previsualizaciones de tecnología...',
    },
    {
        id: 2328,
        label: 'Photoshop > Preferencias > Discos de memoria virtual...',
        placement: 'MenuBar',
        name: 'Discos de memoria virtual...',
    },
    {
        id: 2329,
        label: 'Photoshop > Preferencias > Historial y Content Credentials...',
        placement: 'MenuBar',
        name: 'Historial y Content Credentials...',
    },
    {
        id: 2330,
        label: 'Photoshop > Preferencias > Herramientas...',
        placement: 'MenuBar',
        name: 'Herramientas...',
    },
    {
        id: 2331,
        label: 'Photoshop > Preferencias > Espacio de trabajo...',
        placement: 'MenuBar',
        name: 'Espacio de trabajo...',
    },
    {
        id: 2332,
        label: 'Photoshop > Preferencias > Exportar...',
        placement: 'MenuBar',
        name: 'Exportar...',
    },
    {
        id: 2332,
        label: 'Archivo > Exportar > Preferencias de exportación...',
        placement: 'MenuBar',
        name: 'Preferencias de exportación...',
    },
    {
        id: 2333,
        label: 'Photoshop > Preferencias > Controles mejorados...',
        placement: 'MenuBar',
        name: 'Controles mejorados...',
    },
    {
        id: 2335,
        label: 'Photoshop > Preferencias > Procesamiento de imagen...',
        placement: 'MenuBar',
        name: 'Procesamiento de imagen...',
    },
    {
        id: 2337,
        label: 'Photoshop > Preferencias > Notificaciones...',
        placement: 'MenuBar',
        name: 'Notificaciones...',
    },
    {
        id: 2344,
        label: 'Edición > Ajustes de color...',
        placement: 'MenuBar',
        name: 'Ajustes de color...',
    },
    {
        id: 2345,
        label: 'Edición > Configuración de OpenColorIO...',
        placement: 'MenuBar',
        name: 'Configuración de OpenColorIO...',
    },
    {
        id: 2361,
        label: 'Edición > Purgar > Historias',
        placement: 'MenuBar',
        name: 'Historias',
    },
    {
        id: 2701,
        label: 'Capa > Halos > Quitar halo negro',
        placement: 'MenuBar',
        name: 'Quitar halo negro',
    },
    {
        id: 2703,
        label: 'Capa > Halos > Quitar halo blanco',
        placement: 'MenuBar',
        name: 'Quitar halo blanco',
    },
    {
        id: 2711,
        label: 'Capa > Organizar > Traer al frente',
        placement: 'MenuBar',
        name: 'Traer al frente',
    },
    {
        id: 2712,
        label: 'Capa > Organizar > Hacia delante',
        placement: 'MenuBar',
        name: 'Hacia delante',
    },
    {
        id: 2713,
        label: 'Capa > Organizar > Hacia atrás',
        placement: 'MenuBar',
        name: 'Hacia atrás',
    },
    {
        id: 2714,
        label: 'Capa > Organizar > Enviar detrás',
        placement: 'MenuBar',
        name: 'Enviar detrás',
    },
    {
        id: 2715,
        label: 'Capa > Organizar > Invertir',
        placement: 'MenuBar',
        name: 'Invertir',
    },
    {
        id: 2769,
        label: 'Capa > Filtro inteligente > Deshabilitar filtros inteligentes',
        placement: 'MenuBar',
        name: 'Deshabilitar filtros inteligentes',
    },
    {
        id: 2770,
        label: 'Capa > Filtro inteligente > Borrar filtros inteligentes',
        placement: 'MenuBar',
        name: 'Borrar filtros inteligentes',
    },
    {
        id: 2802,
        label: 'Vista > Ajuste de prueba > A medida...',
        placement: 'MenuBar',
        name: 'A medida...',
    },
    {
        id: 2803,
        label: 'Vista > Ajuste de prueba > Espacio de trabajo CMYK',
        placement: 'MenuBar',
        name: 'Espacio de trabajo CMYK',
    },
    {
        id: 2804,
        label: 'Vista > Ajuste de prueba > Espacio de trabajo de placa del cian',
        placement: 'MenuBar',
        name: 'Espacio de trabajo de placa del cian',
    },
    {
        id: 2805,
        label: 'Vista > Ajuste de prueba > Espacio de trabajo de placa del magenta',
        placement: 'MenuBar',
        name: 'Espacio de trabajo de placa del magenta',
    },
    {
        id: 2806,
        label: 'Vista > Ajuste de prueba > Espacio de trabajo de placa del amarillo',
        placement: 'MenuBar',
        name: 'Espacio de trabajo de placa del amarillo',
    },
    {
        id: 2807,
        label: 'Vista > Ajuste de prueba > Espacio de trabajo de placa del negro',
        placement: 'MenuBar',
        name: 'Espacio de trabajo de placa del negro',
    },
    {
        id: 2808,
        label: 'Vista > Ajuste de prueba > Espacio de trabajo de placas CMY',
        placement: 'MenuBar',
        name: 'Espacio de trabajo de placas CMY',
    },
    {
        id: 2809,
        label: 'Vista > Ajuste de prueba > RGB de Macintosh heredado (Gamma 1.8)',
        placement: 'MenuBar',
        name: 'RGB de Macintosh heredado (Gamma 1.8)',
    },
    {
        id: 2810,
        label: 'Vista > Ajuste de prueba > RGB estándar para Internet (sRGB)',
        placement: 'MenuBar',
        name: 'RGB estándar para Internet (sRGB)',
    },
    {
        id: 2811,
        label: 'Vista > Ajuste de prueba > Monitor RGB',
        placement: 'MenuBar',
        name: 'Monitor RGB',
    },
    {
        id: 2815,
        label: 'Vista > Ajuste de prueba > Daltonismo - Protanopía',
        placement: 'MenuBar',
        name: 'Daltonismo - Protanopía',
    },
    {
        id: 2816,
        label: 'Vista > Ajuste de prueba > Daltonismo - Deuteranopía',
        placement: 'MenuBar',
        name: 'Daltonismo - Deuteranopía',
    },
    {
        id: 2820,
        label: 'Imagen > Análisis > Herramienta Regla',
        placement: 'MenuBar',
        name: 'Herramienta Regla',
    },
    {
        id: 2830,
        label: 'Imagen > Análisis > Colocar marcador de escala...',
        placement: 'MenuBar',
        name: 'Colocar marcador de escala...',
    },
    {
        id: 2841,
        label: 'Imagen > Análisis > Configurar escala de medida > Por defecto',
        placement: 'MenuBar',
        name: 'Por defecto',
    },
    {
        id: 2842,
        label: 'Imagen > Análisis > Configurar escala de medida > A medida...',
        placement: 'MenuBar',
        name: 'A medida...',
    },
    {
        id: 2851,
        label: 'Imagen > Análisis > Seleccionar puntos de datos > A medida...',
        placement: 'MenuBar',
        name: 'A medida...',
    },
    {
        id: 2860,
        label: 'Imagen > Análisis > Grabar medidas',
        placement: 'MenuBar',
        name: 'Grabar medidas',
    },
    {
        id: 2880,
        label: 'Ventana > Registro de medidas',
        placement: 'MenuBar',
        name: 'Registro de medidas',
    },
    {
        id: 2912,
        label: 'Edición > Purgar > Portapapeles',
        placement: 'MenuBar',
        name: 'Portapapeles',
    },
    {
        id: 2915,
        label: 'Edición > Purgar > Todo',
        placement: 'MenuBar',
        name: 'Todo',
    },
    {
        id: 2920,
        label: 'Edición > Purgar > Caché de vídeo',
        placement: 'MenuBar',
        name: 'Caché de vídeo',
    },
    {
        id: 2939,
        label: 'Ventana > Espacio de trabajo > Bloquear espacio de trabajo',
        placement: 'MenuBar',
        name: 'Bloquear espacio de trabajo',
    },
    {
        id: 2940,
        label: 'Vista > Guías > Bloquear guías',
        placement: 'MenuBar',
        name: 'Bloquear guías',
    },
    {
        id: 2950,
        label: 'Vista > Guías > Borrar guías',
        placement: 'MenuBar',
        name: 'Borrar guías',
    },
    {
        id: 2951,
        label: 'Capa > Eliminar > Capas ocultas',
        placement: 'MenuBar',
        name: 'Capas ocultas',
    },
    {
        id: 2952,
        label: 'Vista > Guías > Borrar guías de la mesa de trabajo seleccionada',
        placement: 'MenuBar',
        name: 'Borrar guías de la mesa de trabajo seleccionada',
    },
    {
        id: 2953,
        label: 'Vista > Guías > Borrar guías de lienzo',
        placement: 'MenuBar',
        name: 'Borrar guías de lienzo',
    },
    {
        id: 2956,
        label: 'Capa > Nueva > Grupo a partir de capas...',
        placement: 'MenuBar',
        name: 'Grupo a partir de capas...',
    },
    {
        id: 2957,
        label: 'Capa > Bloquear capas...',
        placement: 'MenuBar',
        name: 'Bloquear capas...',
    },
    {
        id: 2958,
        label: 'Capa > Agrupar capas',
        placement: 'MenuBar',
        name: 'Agrupar capas',
    },
    {
        id: 2959,
        label: 'Capa > Desagrupar capas',
        placement: 'MenuBar',
        name: 'Desagrupar capas',
    },
    {
        id: 2960,
        label: 'Capa > Seleccionar capas enlazadas',
        placement: 'MenuBar',
        name: 'Seleccionar capas enlazadas',
    },
    {
        id: 2961,
        label: 'Capa > Enlazar capas',
        placement: 'MenuBar',
        name: 'Enlazar capas',
    },
    {
        id: 2962,
        label: 'Selección > Todas las capas',
        placement: 'MenuBar',
        name: 'Todas las capas',
    },
    {
        id: 2963,
        label: 'Selección > Deseleccionar capas',
        placement: 'MenuBar',
        name: 'Deseleccionar capas',
    },
    {
        id: 2967,
        label: 'Vista > Bloquear sectores',
        placement: 'MenuBar',
        name: 'Bloquear sectores',
    },
    {
        id: 2969,
        label: 'Vista > Borrar sectores',
        placement: 'MenuBar',
        name: 'Borrar sectores',
    },
    {
        id: 2970,
        label: 'Capa > Nueva > Capa vía Copiar',
        placement: 'MenuBar',
        name: 'Capa vía Copiar',
    },
    {
        id: 2971,
        label: 'Capa > Nueva > Capa vía Cortar',
        placement: 'MenuBar',
        name: 'Capa vía Cortar',
    },
    {
        id: 2972,
        label: 'Capa > Crear máscara de recorte',
        placement: 'MenuBar',
        name: 'Crear máscara de recorte',
    },
    {
        id: 2976,
        label: 'Capa > Nueva > Grupo...',
        placement: 'MenuBar',
        name: 'Grupo...',
    },
    {
        id: 2980,
        label: 'Capa > Objetos inteligentes > Convertir en objeto inteligente',
        placement: 'MenuBar',
        name: 'Convertir en objeto inteligente',
    },
    {
        id: 2981,
        label: 'Capa > Objetos inteligentes > Nuevo objeto inteligente mediante copia',
        placement: 'MenuBar',
        name: 'Nuevo objeto inteligente mediante copia',
    },
    {
        id: 2982,
        label: 'Selección > Buscar capas',
        placement: 'MenuBar',
        name: 'Buscar capas',
    },
    {
        id: 2983,
        label: 'Capa > Cambiar nombre de capa...',
        placement: 'MenuBar',
        name: 'Cambiar nombre de capa...',
    },
    {
        id: 2986,
        label: 'Selección > Aislar capas',
        placement: 'MenuBar',
        name: 'Aislar capas',
    },
    {
        id: 2991,
        label: 'Imagen > Rotación de imagen > 90° a la derecha',
        placement: 'MenuBar',
        name: '90° a la derecha',
    },
    {
        id: 2992,
        label: 'Imagen > Rotación de imagen > 90° a la izquierda',
        placement: 'MenuBar',
        name: '90° a la izquierda',
    },
    {
        id: 2993,
        label: 'Imagen > Rotación de imagen > 180°',
        placement: 'MenuBar',
        name: '180°',
    },
    {
        id: 2994,
        label: 'Imagen > Rotación de imagen > Arbitraria...',
        placement: 'MenuBar',
        name: 'Arbitraria...',
    },
    {
        id: 2996,
        label: 'Imagen > Rotación de imagen > Voltear lienzo horizontal',
        placement: 'MenuBar',
        name: 'Voltear lienzo horizontal',
    },
    {
        id: 2997,
        label: 'Imagen > Rotación de imagen > Voltear lienzo vertical',
        placement: 'MenuBar',
        name: 'Voltear lienzo vertical',
    },
    {
        id: 3056,
        label: 'Imagen > Ajustes > Mezclador de canales...',
        placement: 'MenuBar',
        name: 'Mezclador de canales...',
    },
    {
        id: 3062,
        label: 'Imagen > Ajustes > Mapa de degradado...',
        placement: 'MenuBar',
        name: 'Mapa de degradado...',
    },
    {
        id: 3063,
        label: 'Imagen > Ajustes > Filtro de fotografía...',
        placement: 'MenuBar',
        name: 'Filtro de fotografía...',
    },
    {
        id: 3065,
        label: 'Imagen > Ajustes > Sombras/iluminaciones...',
        placement: 'MenuBar',
        name: 'Sombras/iluminaciones...',
    },
    {
        id: 3066,
        label: 'Imagen > Ajustes > Consulta de colores...',
        placement: 'MenuBar',
        name: 'Consulta de colores...',
    },
    {
        id: 3067,
        label: 'Imagen > Ajustes > Exposición...',
        placement: 'MenuBar',
        name: 'Exposición...',
    },
    {
        id: 3076,
        label: 'Capa > Filtro inteligente > Deshabilitar máscara de filtro',
        placement: 'MenuBar',
        name: 'Deshabilitar máscara de filtro',
    },
    {
        id: 3083,
        label: 'Capa > Nueva capa de ajuste > Exposición...',
        placement: 'MenuBar',
        name: 'Exposición...',
    },
    {
        id: 3085,
        label: 'Capa > Nueva capa de ajuste > Color e intensidad…',
        placement: 'MenuBar',
        name: 'Color e intensidad…',
    },
    {
        id: 3090,
        label: 'Archivo > Colocar elementos enlazados…',
        placement: 'MenuBar',
        name: 'Colocar elementos enlazados…',
    },
    {
        id: 3091,
        label: 'Capa > Objetos inteligentes > Mostrar en Finder',
        placement: 'MenuBar',
        name: 'Mostrar en Finder',
    },
    {
        id: 3092,
        label: 'Archivo > Empaquetar…',
        placement: 'MenuBar',
        name: 'Empaquetar…',
    },
    {
        id: 3098,
        label: 'Archivo > Automatizar > Plugins de generador',
        placement: 'MenuBar',
        name: 'Plugins de generador',
    },
    {
        id: 3187,
        label: 'Ventana > Estilos',
        placement: 'MenuBar',
        name: 'Estilos',
    },
    {
        id: 3300,
        label: 'Texto > Paneles > Panel Carácter',
        placement: 'MenuBar',
        name: 'Panel Carácter',
    },
    {
        id: 3300,
        label: 'Ventana > Carácter',
        placement: 'MenuBar',
        name: 'Carácter',
    },
    {
        id: 3309,
        label: 'Texto > OpenType > Ligaduras estándar',
        placement: 'MenuBar',
        name: 'Ligaduras estándar',
    },
    {
        id: 3310,
        label: 'Texto > OpenType > Estilo antiguo',
        placement: 'MenuBar',
        name: 'Estilo antiguo',
    },
    {
        id: 3327,
        label: 'Texto > OpenType > Medidas proporcionales',
        placement: 'MenuBar',
        name: 'Medidas proporcionales',
    },
    {
        id: 3334,
        label: 'Texto > OpenType > Carácter decorativo',
        placement: 'MenuBar',
        name: 'Carácter decorativo',
    },
    {
        id: 3338,
        label: 'Texto > OpenType > Alternativas contextuales',
        placement: 'MenuBar',
        name: 'Alternativas contextuales',
    },
    {
        id: 3339,
        label: 'Texto > OpenType > Ligaduras discrecionales',
        placement: 'MenuBar',
        name: 'Ligaduras discrecionales',
    },
    {
        id: 3340,
        label: 'Texto > OpenType > Alternativas estilísticas',
        placement: 'MenuBar',
        name: 'Alternativas estilísticas',
    },
    {
        id: 3341,
        label: 'Texto > OpenType > Alternativas para títulos',
        placement: 'MenuBar',
        name: 'Alternativas para títulos',
    },
    {
        id: 3342,
        label: 'Texto > OpenType > Adornos',
        placement: 'MenuBar',
        name: 'Adornos',
    },
    {
        id: 3343,
        label: 'Texto > OpenType > Ordinales',
        placement: 'MenuBar',
        name: 'Ordinales',
    },
    {
        id: 3344,
        label: 'Texto > OpenType > Fracciones',
        placement: 'MenuBar',
        name: 'Fracciones',
    },
    {
        id: 3345,
        label: 'Texto > OpenType > Japonés 78',
        placement: 'MenuBar',
        name: 'Japonés 78',
    },
    {
        id: 3346,
        label: 'Texto > OpenType > Japonés experto',
        placement: 'MenuBar',
        name: 'Japonés experto',
    },
    {
        id: 3347,
        label: 'Texto > OpenType > Japonés tradicional',
        placement: 'MenuBar',
        name: 'Japonés tradicional',
    },
    {
        id: 3348,
        label: 'Texto > OpenType > Kana',
        placement: 'MenuBar',
        name: 'Kana',
    },
    {
        id: 3349,
        label: 'Texto > OpenType > Latino cursiva',
        placement: 'MenuBar',
        name: 'Latino cursiva',
    },
    {
        id: 3350,
        label: 'Texto > Paneles > Panel Párrafo',
        placement: 'MenuBar',
        name: 'Panel Párrafo',
    },
    {
        id: 3350,
        label: 'Ventana > Párrafo',
        placement: 'MenuBar',
        name: 'Párrafo',
    },
    {
        id: 3370,
        label: 'Texto > Suavizar > Ninguno',
        placement: 'MenuBar',
        name: 'Ninguno',
    },
    {
        id: 3371,
        label: 'Texto > Suavizar > Nítido',
        placement: 'MenuBar',
        name: 'Nítido',
    },
    {
        id: 3372,
        label: 'Texto > Suavizar > Fuerte',
        placement: 'MenuBar',
        name: 'Fuerte',
    },
    {
        id: 3373,
        label: 'Texto > Suavizar > Redondeado',
        placement: 'MenuBar',
        name: 'Redondeado',
    },
    {
        id: 3374,
        label: 'Texto > Suavizar > Enfocado',
        placement: 'MenuBar',
        name: 'Enfocado',
    },
    {
        id: 3375,
        label: 'Texto > Suavizar > Mac LCD',
        placement: 'MenuBar',
        name: 'Mac LCD',
    },
    {
        id: 3376,
        label: 'Texto > Suavizar > Mac',
        placement: 'MenuBar',
        name: 'Mac',
    },
    {
        id: 3382,
        label: 'Texto > Convertir forma de texto',
        placement: 'MenuBar',
        name: 'Convertir forma de texto',
    },
    {
        id: 3390,
        label: 'Texto > Actualizar todas las capas de texto',
        placement: 'MenuBar',
        name: 'Actualizar todas las capas de texto',
    },
    {
        id: 3392,
        label: 'Edición > Revisar ortografía...',
        placement: 'MenuBar',
        name: 'Revisar ortografía...',
    },
    {
        id: 3393,
        label: 'Edición > Buscar y reemplazar texto...',
        placement: 'MenuBar',
        name: 'Buscar y reemplazar texto...',
    },
    {
        id: 3409,
        label: 'Capa > Combinar formas > Unir formas',
        placement: 'MenuBar',
        name: 'Unir formas',
    },
    {
        id: 3410,
        label: 'Capa > Combinar formas > Restar forma frontal',
        placement: 'MenuBar',
        name: 'Restar forma frontal',
    },
    {
        id: 3411,
        label: 'Capa > Combinar formas > Unir formas en superposición',
        placement: 'MenuBar',
        name: 'Unir formas en superposición',
    },
    {
        id: 3412,
        label: 'Capa > Combinar formas > Restar formas en superposición',
        placement: 'MenuBar',
        name: 'Restar formas en superposición',
    },
    {
        id: 3438,
        label: 'Capa > Copiar SVG',
        placement: 'MenuBar',
        name: 'Copiar SVG',
    },
    {
        id: 3439,
        label: 'Capa > Copiar CSS',
        placement: 'MenuBar',
        name: 'Copiar CSS',
    },
    {
        id: 3443,
        label: 'Archivo > Exportar > Exportar como...',
        placement: 'MenuBar',
        name: 'Exportar como...',
    },
    {
        id: 3444,
        label: 'Archivo > Exportar > Exportación rápida como PNG',
        placement: 'MenuBar',
        name: 'Exportación rápida como PNG',
    },
    {
        id: 3446,
        label: 'Capa > Exportación rápida como PNG',
        placement: 'MenuBar',
        name: 'Exportación rápida como PNG',
    },
    {
        id: 3447,
        label: 'Capa > Exportar como...',
        placement: 'MenuBar',
        name: 'Exportar como...',
    },
    {
        id: 3451,
        label: 'Texto > Opciones de idioma > Dígitos árabes IAD (izquierda a derecha) - 123%',
        placement: 'MenuBar',
        name: 'Dígitos árabes IAD (izquierda a derecha) - 123%',
    },
    {
        id: 3452,
        label: 'Texto > Opciones de idioma > Dígitos farsi',
        placement: 'MenuBar',
        name: 'Dígitos farsi',
    },
    {
        id: 3453,
        label: 'Texto > Opciones de idioma > Dígitos hindi',
        placement: 'MenuBar',
        name: 'Dígitos hindi',
    },
    {
        id: 3459,
        label: 'Texto > Opciones de idioma > Dígitos árabes DAI (derecha a izquierda) - 123%',
        placement: 'MenuBar',
        name: 'Dígitos árabes DAI (derecha a izquierda) - 123%',
    },
    {
        id: 3500,
        label: 'Vista > Extras',
        placement: 'MenuBar',
        name: 'Extras',
    },
    {
        id: 3501,
        label: 'Vista > Mostrar > Bordes de la selección',
        placement: 'MenuBar',
        name: 'Bordes de la selección',
    },
    {
        id: 3502,
        label: 'Vista > Mostrar > Trazado de destino',
        placement: 'MenuBar',
        name: 'Trazado de destino',
    },
    {
        id: 3503,
        label: 'Vista > Mostrar > Guías',
        placement: 'MenuBar',
        name: 'Guías',
    },
    {
        id: 3504,
        label: 'Vista > Mostrar > Cuadrícula',
        placement: 'MenuBar',
        name: 'Cuadrícula',
    },
    {
        id: 3505,
        label: 'Vista > Mostrar > Sectores',
        placement: 'MenuBar',
        name: 'Sectores',
    },
    {
        id: 3506,
        label: 'Vista > Mostrar > Notas',
        placement: 'MenuBar',
        name: 'Notas',
    },
    {
        id: 3507,
        label: 'Vista > Mostrar > Todo',
        placement: 'MenuBar',
        name: 'Todo',
    },
    {
        id: 3508,
        label: 'Vista > Mostrar > Ninguno',
        placement: 'MenuBar',
        name: 'Ninguno',
    },
    {
        id: 3510,
        label: 'Vista > Mostrar > Opciones de Mostrar extras...',
        placement: 'MenuBar',
        name: 'Opciones de Mostrar extras...',
    },
    {
        id: 3511,
        label: 'Vista > Mostrar > Guías inteligentes',
        placement: 'MenuBar',
        name: 'Guías inteligentes',
    },
    {
        id: 3512,
        label: 'Vista > Mostrar > Bordes de capa',
        placement: 'MenuBar',
        name: 'Bordes de capa',
    },
    {
        id: 3513,
        label: 'Vista > Mostrar > Recuento',
        placement: 'MenuBar',
        name: 'Recuento',
    },
    {
        id: 3514,
        label: 'Vista > Mostrar > Cuadrícula de píxeles',
        placement: 'MenuBar',
        name: 'Cuadrícula de píxeles',
    },
    {
        id: 3517,
        label: 'Vista > Mostrar > Malla',
        placement: 'MenuBar',
        name: 'Malla',
    },
    {
        id: 3520,
        label: 'Vista > Ajustar',
        placement: 'MenuBar',
        name: 'Ajustar',
    },
    {
        id: 3521,
        label: 'Vista > Ajustar a > Guías',
        placement: 'MenuBar',
        name: 'Guías',
    },
    {
        id: 3522,
        label: 'Vista > Ajustar a > Cuadrícula',
        placement: 'MenuBar',
        name: 'Cuadrícula',
    },
    {
        id: 3523,
        label: 'Vista > Ajustar a > Sectores',
        placement: 'MenuBar',
        name: 'Sectores',
    },
    {
        id: 3524,
        label: 'Vista > Ajustar a > Límites del documento',
        placement: 'MenuBar',
        name: 'Límites del documento',
    },
    {
        id: 3527,
        label: 'Vista > Ajustar a > Todo',
        placement: 'MenuBar',
        name: 'Todo',
    },
    {
        id: 3528,
        label: 'Vista > Ajustar a > Ninguno',
        placement: 'MenuBar',
        name: 'Ninguno',
    },
    {
        id: 3530,
        label: 'Vista > Ajustar a > Capas',
        placement: 'MenuBar',
        name: 'Capas',
    },
    {
        id: 3532,
        label: 'Vista > Mostrar > Límites de la vista preliminar de motivo',
        placement: 'MenuBar',
        name: 'Límites de la vista preliminar de motivo',
    },
    {
        id: 3533,
        label: 'Vista > Mostrar > Guías de mesa de trabajo',
        placement: 'MenuBar',
        name: 'Guías de mesa de trabajo',
    },
    {
        id: 3535,
        label: 'Vista > Mostrar > Nombres de mesas de trabajo',
        placement: 'MenuBar',
        name: 'Nombres de mesas de trabajo',
    },
    {
        id: 3536,
        label: 'Vista > Mostrar > Guías del lienzo',
        placement: 'MenuBar',
        name: 'Guías del lienzo',
    },
    {
        id: 3541,
        label: 'Capa > Rasterizar > Forma',
        placement: 'MenuBar',
        name: 'Forma',
    },
    {
        id: 3542,
        label: 'Capa > Rasterizar > Texto',
        placement: 'MenuBar',
        name: 'Texto',
    },
    {
        id: 3542,
        label: 'Texto > Rasterizar capa de texto',
        placement: 'MenuBar',
        name: 'Rasterizar capa de texto',
    },
    {
        id: 3544,
        label: 'Capa > Rasterizar > Contenido de relleno',
        placement: 'MenuBar',
        name: 'Contenido de relleno',
    },
    {
        id: 3545,
        label: 'Capa > Rasterizar > Todas las capas',
        placement: 'MenuBar',
        name: 'Todas las capas',
    },
    {
        id: 3547,
        label: 'Capa > Rasterizar > Capa',
        placement: 'MenuBar',
        name: 'Capa',
    },
    {
        id: 3549,
        label: 'Capa > Objetos inteligentes > Rasterizar',
        placement: 'MenuBar',
        name: 'Rasterizar',
    },
    {
        id: 3549,
        label: 'Capa > Rasterizar > Objeto inteligente',
        placement: 'MenuBar',
        name: 'Objeto inteligente',
    },
    {
        id: 3551,
        label: 'Capa > Rasterizar > Vídeo',
        placement: 'MenuBar',
        name: 'Vídeo',
    },
    {
        id: 3553,
        label: 'Capa > Rasterizar > 3D',
        placement: 'MenuBar',
        name: '3D',
    },
    {
        id: 3555,
        label: 'Capa > Capas de vídeo > Rasterizar',
        placement: 'MenuBar',
        name: 'Rasterizar',
    },
    {
        id: 3557,
        label: 'Capa > Rasterizar > Estilo de capa',
        placement: 'MenuBar',
        name: 'Estilo de capa',
    },
    {
        id: 3561,
        label: 'Capa > Rasterizar > Generativa',
        placement: 'MenuBar',
        name: 'Generativa',
    },
    {
        id: 3585,
        label: 'Vista > Mostrar > Editar posiciones',
        placement: 'MenuBar',
        name: 'Editar posiciones',
    },
    {
        id: 3911,
        label: 'Filtro > Filtros de próxima generación > Blur (Gaussian)',
        placement: 'MenuBar',
        name: 'Blur (Gaussian)',
    },
    {
        id: 4002,
        label: 'Ayuda > Actualizaciones...',
        placement: 'MenuBar',
        name: 'Actualizaciones...',
    },
    {
        id: 4210,
        label: 'Ventana > Herramientas preestablecidas',
        placement: 'MenuBar',
        name: 'Herramientas preestablecidas',
    },
    {
        id: 5059,
        label: 'Capa > Máscara de capa > Eliminar',
        placement: 'MenuBar',
        name: 'Eliminar',
    },
    {
        id: 5068,
        label: 'Edición > Pegado especial > Pegar fuera',
        placement: 'MenuBar',
        name: 'Pegar fuera',
    },
    {
        id: 5069,
        label: 'Selección > Editar en modo Máscara rápida',
        placement: 'MenuBar',
        name: 'Editar en modo Máscara rápida',
    },
    {
        id: 5085,
        label: 'Capa > Máscara de capa > Enlazar',
        placement: 'MenuBar',
        name: 'Enlazar',
    },
    {
        id: 5095,
        label: 'Capa > Máscara de capa > Aplicar',
        placement: 'MenuBar',
        name: 'Aplicar',
    },
    {
        id: 5115,
        label: 'Ventana > Espacio de trabajo > Nuevo espacio de trabajo...',
        placement: 'MenuBar',
        name: 'Nuevo espacio de trabajo...',
    },
    {
        id: 5116,
        label: 'Ventana > Espacio de trabajo > Eliminar espacio de trabajo...',
        placement: 'MenuBar',
        name: 'Eliminar espacio de trabajo...',
    },
    {
        id: 5117,
        label: 'Ventana > Espacio de trabajo > Restaurar Aspectos esenciales',
        placement: 'MenuBar',
        name: 'Restaurar Aspectos esenciales',
    },
    {
        id: 5217,
        label: 'Capa > Nuevo sector basado en capa',
        placement: 'MenuBar',
        name: 'Nuevo sector basado en capa',
    },
    {
        id: 5226,
        label: 'Capa > Filtro inteligente > Eliminar máscara de filtro',
        placement: 'MenuBar',
        name: 'Eliminar máscara de filtro',
    },
    {
        id: 5613,
        label: 'Vista > Guías > Guía nueva...',
        placement: 'MenuBar',
        name: 'Guía nueva...',
    },
    {
        id: 5614,
        label: 'Vista > Guías > Nueva composición de guía…',
        placement: 'MenuBar',
        name: 'Nueva composición de guía…',
    },
    {
        id: 5615,
        label: 'Vista > Guías > Nuevas guías de forma',
        placement: 'MenuBar',
        name: 'Nuevas guías de forma',
    },
    {
        id: 5624,
        label: 'Edición > Definir forma personalizada...',
        placement: 'MenuBar',
        name: 'Definir forma personalizada...',
    },
    {
        id: 5634,
        label: 'Ventana > Espacio de trabajo > Aspectos esenciales (Por defecto)',
        placement: 'MenuBar',
        name: 'Aspectos esenciales (Por defecto)',
    },
    {
        id: 5929,
        label: 'Ventana > Organizar > Traer todo al frente',
        placement: 'MenuBar',
        name: 'Traer todo al frente',
    },
    {
        id: 5930,
        label: 'Ventana > Organizar > Cascada',
        placement: 'MenuBar',
        name: 'Cascada',
    },
    {
        id: 5931,
        label: 'Ventana > Organizar > Segmentar',
        placement: 'MenuBar',
        name: 'Segmentar',
    },
    {
        id: 5932,
        label: 'Ventana > Organizar > Minimizar',
        placement: 'MenuBar',
        name: 'Minimizar',
    },
    {
        id: 5933,
        label: 'Ventana > Organizar > Segmentar todo en vertical',
        placement: 'MenuBar',
        name: 'Segmentar todo en vertical',
    },
    {
        id: 5934,
        label: 'Ventana > Organizar > Segmentar todo en horizontal',
        placement: 'MenuBar',
        name: 'Segmentar todo en horizontal',
    },
    {
        id: 5935,
        label: 'Ventana > Organizar > Horizontal de 2 hojas',
        placement: 'MenuBar',
        name: 'Horizontal de 2 hojas',
    },
    {
        id: 5936,
        label: 'Ventana > Organizar > Vertical de 2 hojas',
        placement: 'MenuBar',
        name: 'Vertical de 2 hojas',
    },
    {
        id: 5937,
        label: 'Ventana > Organizar > Horizontal de 3 hojas',
        placement: 'MenuBar',
        name: 'Horizontal de 3 hojas',
    },
    {
        id: 5938,
        label: 'Ventana > Organizar > Vertical de 3 hojas',
        placement: 'MenuBar',
        name: 'Vertical de 3 hojas',
    },
    {
        id: 5939,
        label: 'Ventana > Organizar > 3 hojas apiladas',
        placement: 'MenuBar',
        name: '3 hojas apiladas',
    },
    {
        id: 5940,
        label: 'Ventana > Organizar > 4 hojas',
        placement: 'MenuBar',
        name: '4 hojas',
    },
    {
        id: 5941,
        label: 'Ventana > Organizar > 6 hojas',
        placement: 'MenuBar',
        name: '6 hojas',
    },
    {
        id: 5956,
        label: 'Ayuda > Ayuda de Photoshop...',
        placement: 'MenuBar',
        name: 'Ayuda de Photoshop...',
    },
    {
        id: 5957,
        label: 'Edición > Buscar',
        placement: 'MenuBar',
        name: 'Buscar',
    },
    {
        id: 5960,
        label: 'Ventana > Organizar > Coincidir zoom',
        placement: 'MenuBar',
        name: 'Coincidir zoom',
    },
    {
        id: 5962,
        label: 'Ventana > Organizar > Coincidir ubicación',
        placement: 'MenuBar',
        name: 'Coincidir ubicación',
    },
    {
        id: 5963,
        label: 'Ventana > Organizar > Coincidir rotación',
        placement: 'MenuBar',
        name: 'Coincidir rotación',
    },
    {
        id: 5964,
        label: 'Ventana > Organizar > Coincidir todo',
        placement: 'MenuBar',
        name: 'Coincidir todo',
    },
    {
        id: 5966,
        label: 'Archivo > Compartir para revisión',
        placement: 'MenuBar',
        name: 'Compartir para revisión',
    },
    {
        id: 5967,
        label: 'Archivo > Invitar a editar...',
        placement: 'MenuBar',
        name: 'Invitar a editar...',
    },
    {
        id: 5968,
        label: 'Archivo > Exportar > Enviar a Tableros de Firefly',
        placement: 'MenuBar',
        name: 'Enviar a Tableros de Firefly',
    },
    {
        id: 5980,
        label: 'Edición > Métodos abreviados de teclado...',
        placement: 'MenuBar',
        name: 'Métodos abreviados de teclado...',
    },
    {
        id: 5981,
        label: 'Ventana > Espacio de trabajo > Métodos abreviados de teclado y menús...',
        placement: 'MenuBar',
        name: 'Métodos abreviados de teclado y menús...',
    },
    {
        id: 5982,
        label: 'Edición > Menús...',
        placement: 'MenuBar',
        name: 'Menús...',
    },
    {
        id: 5983,
        label: 'Edición > Barra de herramientas...',
        placement: 'MenuBar',
        name: 'Barra de herramientas...',
    },
    {
        id: 5991,
        label: 'Vista > Modo de pantalla > Modo de pantalla estándar',
        placement: 'MenuBar',
        name: 'Modo de pantalla estándar',
    },
    {
        id: 5992,
        label: 'Vista > Modo de pantalla > Modo de pantalla entera con barra de menús',
        placement: 'MenuBar',
        name: 'Modo de pantalla entera con barra de menús',
    },
    {
        id: 5993,
        label: 'Vista > Modo de pantalla > Modo de pantalla entera',
        placement: 'MenuBar',
        name: 'Modo de pantalla entera',
    },
    {
        id: 5996,
        label: 'Ventana > Organizar > Hacer flotante en ventana',
        placement: 'MenuBar',
        name: 'Hacer flotante en ventana',
    },
    {
        id: 5997,
        label: 'Ventana > Organizar > Hacer flotante todo en ventanas',
        placement: 'MenuBar',
        name: 'Hacer flotante todo en ventanas',
    },
    {
        id: 5998,
        label: 'Ventana > Organizar > Consolidar todo en fichas',
        placement: 'MenuBar',
        name: 'Consolidar todo en fichas',
    },
    {
        id: 6300,
        label: 'Capa > Nueva capa de relleno > Color uniforme...',
        placement: 'MenuBar',
        name: 'Color uniforme...',
    },
    {
        id: 6301,
        label: 'Capa > Nueva capa de relleno > Degradado...',
        placement: 'MenuBar',
        name: 'Degradado...',
    },
    {
        id: 6302,
        label: 'Capa > Nueva capa de relleno > Motivo...',
        placement: 'MenuBar',
        name: 'Motivo...',
    },
    {
        id: 6303,
        label: 'Capa > Nueva capa de ajuste > Niveles...',
        placement: 'MenuBar',
        name: 'Niveles...',
    },
    {
        id: 6304,
        label: 'Capa > Nueva capa de ajuste > Curvas...',
        placement: 'MenuBar',
        name: 'Curvas...',
    },
    {
        id: 6305,
        label: 'Capa > Nueva capa de ajuste > Equilibrio de color...',
        placement: 'MenuBar',
        name: 'Equilibrio de color...',
    },
    {
        id: 6306,
        label: 'Capa > Nueva capa de ajuste > Brillo/contraste...',
        placement: 'MenuBar',
        name: 'Brillo/contraste...',
    },
    {
        id: 6308,
        label: 'Capa > Nueva capa de ajuste > Tono/saturación...',
        placement: 'MenuBar',
        name: 'Tono/saturación...',
    },
    {
        id: 6309,
        label: 'Capa > Nueva capa de ajuste > Corrección selectiva...',
        placement: 'MenuBar',
        name: 'Corrección selectiva...',
    },
    {
        id: 6310,
        label: 'Capa > Nueva capa de ajuste > Mezclador de canales...',
        placement: 'MenuBar',
        name: 'Mezclador de canales...',
    },
    {
        id: 6311,
        label: 'Capa > Nueva capa de ajuste > Mapa de degradado...',
        placement: 'MenuBar',
        name: 'Mapa de degradado...',
    },
    {
        id: 6312,
        label: 'Capa > Nueva capa de ajuste > Filtro de fotografía...',
        placement: 'MenuBar',
        name: 'Filtro de fotografía...',
    },
    {
        id: 6313,
        label: 'Capa > Nueva capa de ajuste > Invertir...',
        placement: 'MenuBar',
        name: 'Invertir...',
    },
    {
        id: 6314,
        label: 'Capa > Nueva capa de ajuste > Umbral...',
        placement: 'MenuBar',
        name: 'Umbral...',
    },
    {
        id: 6315,
        label: 'Capa > Nueva capa de ajuste > Posterizar...',
        placement: 'MenuBar',
        name: 'Posterizar...',
    },
    {
        id: 6332,
        label: 'Capa > Objetos inteligentes > Editar contenido',
        placement: 'MenuBar',
        name: 'Editar contenido',
    },
    {
        id: 6333,
        label: 'Capa > Objetos inteligentes > Reemplazar contenido...',
        placement: 'MenuBar',
        name: 'Reemplazar contenido...',
    },
    {
        id: 6334,
        label: 'Capa > Objetos inteligentes > Exportar contenido...',
        placement: 'MenuBar',
        name: 'Exportar contenido...',
    },
    {
        id: 6337,
        label: 'Capa > Nueva capa de ajuste > Consulta de colores...',
        placement: 'MenuBar',
        name: 'Consulta de colores...',
    },
    {
        id: 6339,
        label: 'Capa > Objetos inteligentes > Convertir en enlazado...',
        placement: 'MenuBar',
        name: 'Convertir en enlazado...',
    },
    {
        id: 6340,
        label: 'Capa > Objetos inteligentes > Volver a enlazar al archivo…',
        placement: 'MenuBar',
        name: 'Volver a enlazar al archivo…',
    },
    {
        id: 6341,
        label: 'Capa > Objetos inteligentes > Volver a enlazar al gráfico de biblioteca…',
        placement: 'MenuBar',
        name: 'Volver a enlazar al gráfico de biblioteca…',
    },
    {
        id: 6342,
        label: 'Capa > Objetos inteligentes > Actualizar contenido modificado',
        placement: 'MenuBar',
        name: 'Actualizar contenido modificado',
    },
    {
        id: 6343,
        label: 'Capa > Objetos inteligentes > Actualizar todo el contenido modificado',
        placement: 'MenuBar',
        name: 'Actualizar todo el contenido modificado',
    },
    {
        id: 6345,
        label: 'Capa > Objetos inteligentes > Incrustar elementos enlazados',
        placement: 'MenuBar',
        name: 'Incrustar elementos enlazados',
    },
    {
        id: 6346,
        label: 'Capa > Objetos inteligentes > Incrustar todos los elementos enlazados',
        placement: 'MenuBar',
        name: 'Incrustar todos los elementos enlazados',
    },
    {
        id: 6347,
        label: 'Capa > Objetos inteligentes > Restaurar transformación',
        placement: 'MenuBar',
        name: 'Restaurar transformación',
    },
    {
        id: 6348,
        label: 'Capa > Nueva capa de ajuste > Blanco y negro...',
        placement: 'MenuBar',
        name: 'Blanco y negro...',
    },
    {
        id: 6351,
        label: 'Capa > Capas de vídeo > Nueva capa de vídeo desde archivo...',
        placement: 'MenuBar',
        name: 'Nueva capa de vídeo desde archivo...',
    },
    {
        id: 6352,
        label: 'Capa > Capas de vídeo > Nueva capa de vídeo vacía',
        placement: 'MenuBar',
        name: 'Nueva capa de vídeo vacía',
    },
    {
        id: 6353,
        label: 'Capa > Capas de vídeo > Insertar cuadro en blanco',
        placement: 'MenuBar',
        name: 'Insertar cuadro en blanco',
    },
    {
        id: 6354,
        label: 'Capa > Capas de vídeo > Duplicar cuadro',
        placement: 'MenuBar',
        name: 'Duplicar cuadro',
    },
    {
        id: 6355,
        label: 'Capa > Capas de vídeo > Eliminar cuadro',
        placement: 'MenuBar',
        name: 'Eliminar cuadro',
    },
    {
        id: 6356,
        label: 'Capa > Capas de vídeo > Interpretar metraje...',
        placement: 'MenuBar',
        name: 'Interpretar metraje...',
    },
    {
        id: 6357,
        label: 'Capa > Capas de vídeo > Reemplazar metraje...',
        placement: 'MenuBar',
        name: 'Reemplazar metraje...',
    },
    {
        id: 6358,
        label: 'Capa > Capas de vídeo > Mostrar vídeo modificado',
        placement: 'MenuBar',
        name: 'Mostrar vídeo modificado',
    },
    {
        id: 6360,
        label: 'Capa > Capas de vídeo > Restaurar cuadro',
        placement: 'MenuBar',
        name: 'Restaurar cuadro',
    },
    {
        id: 6361,
        label: 'Capa > Capas de vídeo > Restaurar todos los cuadros',
        placement: 'MenuBar',
        name: 'Restaurar todos los cuadros',
    },
    {
        id: 6362,
        label: 'Archivo > Importar > Cuadros de vídeo a capas...',
        placement: 'MenuBar',
        name: 'Cuadros de vídeo a capas...',
    },
    {
        id: 6363,
        label: 'Capa > Capas de vídeo > Volver a cargar cuadro',
        placement: 'MenuBar',
        name: 'Volver a cargar cuadro',
    },
    {
        id: 6400,
        label: 'Vista > Opciones de previsualización de 32 bits...',
        placement: 'MenuBar',
        name: 'Opciones de previsualización de 32 bits...',
    },
    {
        id: 6432,
        label: 'Capa > Objetos inteligentes > Modo de apilamiento > Ninguno',
        placement: 'MenuBar',
        name: 'Ninguno',
    },
    {
        id: 6440,
        label: 'Filtro > Convertir para filtros inteligentes',
        placement: 'MenuBar',
        name: 'Convertir para filtros inteligentes',
    },
    {
        id: 6478,
        label: 'Ventana > Propiedades',
        placement: 'MenuBar',
        name: 'Propiedades',
    },
    {
        id: 6479,
        label: 'Ventana > Ajustes',
        placement: 'MenuBar',
        name: 'Ajustes',
    },
    {
        id: 6651,
        label: 'Capa > Nueva capa de ajuste > Claridad y borrar neblina…',
        placement: 'MenuBar',
        name: 'Claridad y borrar neblina…',
    },
    {
        id: 6652,
        label: 'Capa > Nueva capa de ajuste > Granulado…',
        placement: 'MenuBar',
        name: 'Granulado…',
    },
    {
        id: 7763,
        label: 'Ventana > Degradados',
        placement: 'MenuBar',
        name: 'Degradados',
    },
    {
        id: 7767,
        label: 'Ventana > Motivos',
        placement: 'MenuBar',
        name: 'Motivos',
    },
    {
        id: 7772,
        label: 'Ventana > Formas',
        placement: 'MenuBar',
        name: 'Formas',
    },
    {
        id: 7785,
        label: 'Ventana > Content Credentials (Beta)',
        placement: 'MenuBar',
        name: 'Content Credentials (Beta)',
    },
    {
        id: 7788,
        label: 'Ventana > Materiales',
        placement: 'MenuBar',
        name: 'Materiales',
    },
    {
        id: 7789,
        label: 'Filtro > Filtros paramétricos...',
        placement: 'MenuBar',
        name: 'Filtros paramétricos...',
    },
    {
        id: 7800,
        label: 'Imagen > Aplicar conjunto de datos...',
        placement: 'MenuBar',
        name: 'Aplicar conjunto de datos...',
    },
    {
        id: 7802,
        label: 'Imagen > Variables > Definir...',
        placement: 'MenuBar',
        name: 'Definir...',
    },
    {
        id: 7803,
        label: 'Imagen > Variables > Conjuntos de datos...',
        placement: 'MenuBar',
        name: 'Conjuntos de datos...',
    },
    {
        id: 7805,
        label: 'Archivo > Importar > Conjuntos de datos variables...',
        placement: 'MenuBar',
        name: 'Conjuntos de datos variables...',
    },
    {
        id: 7806,
        label: 'Archivo > Exportar > Conjuntos de datos como archivos...',
        placement: 'MenuBar',
        name: 'Conjuntos de datos como archivos...',
    },
    {
        id: 7900,
        label: 'Imagen > Análisis > Herramienta Recuento',
        placement: 'MenuBar',
        name: 'Herramienta Recuento',
    },
    {
        id: 7930,
        label: 'Ventana > Marco de aplicación',
        placement: 'MenuBar',
        name: 'Marco de aplicación',
    },
    {
        id: 8820,
        label: 'Filtro > Neural Filters...',
        placement: 'MenuBar',
        name: 'Neural Filters...',
    },
    {
        id: 9066,
        label: 'Texto > Paneles > Panel Estilos de carácter',
        placement: 'MenuBar',
        name: 'Panel Estilos de carácter',
    },
    {
        id: 9066,
        label: 'Ventana > Estilos de carácter',
        placement: 'MenuBar',
        name: 'Estilos de carácter',
    },
    {
        id: 9067,
        label: 'Texto > Paneles > Panel Estilos de párrafo',
        placement: 'MenuBar',
        name: 'Panel Estilos de párrafo',
    },
    {
        id: 9067,
        label: 'Ventana > Estilos de párrafo',
        placement: 'MenuBar',
        name: 'Estilos de párrafo',
    },
    {
        id: 9068,
        label: 'Texto > Paneles > Panel Pictogramas',
        placement: 'MenuBar',
        name: 'Panel Pictogramas',
    },
    {
        id: 9068,
        label: 'Ventana > Pictogramas',
        placement: 'MenuBar',
        name: 'Pictogramas',
    },
    {
        id: 9086,
        label: 'Texto > OpenType > Justificación alternativa',
        placement: 'MenuBar',
        name: 'Justificación alternativa',
    },
    {
        id: 9087,
        label: 'Texto > Administrar las fuentes que faltan',
        placement: 'MenuBar',
        name: 'Administrar las fuentes que faltan',
    },
    {
        id: 9100,
        label: 'Texto > Opciones de idioma > Funciones predeterminadas',
        placement: 'MenuBar',
        name: 'Funciones predeterminadas',
    },
    {
        id: 9101,
        label: 'Texto > Opciones de idioma > Funciones de Asia Oriental',
        placement: 'MenuBar',
        name: 'Funciones de Asia Oriental',
    },
    {
        id: 9102,
        label: 'Texto > Opciones de idioma > Funciones de Oriente Medio',
        placement: 'MenuBar',
        name: 'Funciones de Oriente Medio',
    },
    {
        id: 9109,
        label: 'Texto > Tamaño de previsualización de fuentes > Ninguno',
        placement: 'MenuBar',
        name: 'Ninguno',
    },
    {
        id: 9110,
        label: 'Texto > Tamaño de previsualización de fuentes > Pequeño',
        placement: 'MenuBar',
        name: 'Pequeño',
    },
    {
        id: 9111,
        label: 'Texto > Tamaño de previsualización de fuentes > Mediano',
        placement: 'MenuBar',
        name: 'Mediano',
    },
    {
        id: 9112,
        label: 'Texto > Tamaño de previsualización de fuentes > Grande',
        placement: 'MenuBar',
        name: 'Grande',
    },
    {
        id: 9113,
        label: 'Texto > Tamaño de previsualización de fuentes > Extragrande',
        placement: 'MenuBar',
        name: 'Extragrande',
    },
    {
        id: 9114,
        label: 'Texto > Tamaño de previsualización de fuentes > Enorme',
        placement: 'MenuBar',
        name: 'Enorme',
    },
    {
        id: 9119,
        label: 'Texto > Pegar Lorem Ipsum',
        placement: 'MenuBar',
        name: 'Pegar Lorem Ipsum',
    },
    {
        id: 9121,
        label: 'Texto > Cargar estilos de texto predeterminados',
        placement: 'MenuBar',
        name: 'Cargar estilos de texto predeterminados',
    },
    {
        id: 9122,
        label: 'Texto > Guardar estilos de texto predeterminados',
        placement: 'MenuBar',
        name: 'Guardar estilos de texto predeterminados',
    },
    {
        id: 9123,
        label: 'Texto > Coincidencia de fuentes...',
        placement: 'MenuBar',
        name: 'Coincidencia de fuentes...',
    },
    {
        id: 9130,
        label: 'Texto > Opciones de idioma > Alineación latina vertical estándar',
        placement: 'MenuBar',
        name: 'Alineación latina vertical estándar',
    },
    {
        id: 9131,
        label: 'Texto > Opciones de idioma > Tate-chu-yoko',
        placement: 'MenuBar',
        name: 'Tate-chu-yoko',
    },
    {
        id: 9132,
        label: 'Texto > Opciones de idioma > Interlineado superior a superior',
        placement: 'MenuBar',
        name: 'Interlineado superior a superior',
    },
    {
        id: 9133,
        label: 'Texto > Opciones de idioma > Interlineado inferior a inferior',
        placement: 'MenuBar',
        name: 'Interlineado inferior a inferior',
    },
    {
        id: 9137,
        label: 'Texto > Opciones de idioma > Kashidas',
        placement: 'MenuBar',
        name: 'Kashidas',
    },
    {
        id: 9138,
        label: 'Texto > Opciones de idioma > Dirección predeterminada',
        placement: 'MenuBar',
        name: 'Dirección predeterminada',
    },
    {
        id: 9139,
        label: 'Texto > Opciones de idioma > Dirección de caracteres de izquierda a derecha',
        placement: 'MenuBar',
        name: 'Dirección de caracteres de izquierda a derecha',
    },
    {
        id: 9140,
        label: 'Texto > Opciones de idioma > Dirección de caracteres de derecha a izquierda',
        placement: 'MenuBar',
        name: 'Dirección de caracteres de derecha a izquierda',
    },
    {
        id: 9143,
        label: 'Edición > Pegado especial > Pegar sin formato',
        placement: 'MenuBar',
        name: 'Pegar sin formato',
    },
    {
        id: 9220,
        label: 'Capa > Nueva > Mesa de trabajo...',
        placement: 'MenuBar',
        name: 'Mesa de trabajo...',
    },
    {
        id: 9221,
        label: 'Capa > Nueva > Mesa de trabajo a partir de grupo',
        placement: 'MenuBar',
        name: 'Mesa de trabajo a partir de grupo',
    },
    {
        id: 9222,
        label: 'Capa > Nueva > Mesa de trabajo a partir de capas…',
        placement: 'MenuBar',
        name: 'Mesa de trabajo a partir de capas…',
    },
    {
        id: 9252,
        label: 'Capa > Nueva > Marco a partir de capas...',
        placement: 'MenuBar',
        name: 'Marco a partir de capas...',
    },
    {
        id: 9255,
        label: 'Capa > Nueva > Convertir en marco',
        placement: 'MenuBar',
        name: 'Convertir en marco',
    },
    {
        id: 9600,
        label: 'Ventana > Barra de tareas contextuales',
        placement: 'MenuBar',
        name: 'Barra de tareas contextuales',
    },
    {
        id: 11600,
        label: 'Capa > Armonizar',
        placement: 'MenuBar',
        name: 'Armonizar',
    },
    {
        id: 15004,
        label: 'Ayuda > Información del sistema...',
        placement: 'MenuBar',
        name: 'Información del sistema...',
    },
    {
        id: 15009,
        label: 'Ayuda > Compatibilidad de GPU...',
        placement: 'MenuBar',
        name: 'Compatibilidad de GPU...',
    },
    {
        id: 15019,
        label: 'Ayuda > Más información sobre créditos generativos',
        placement: 'MenuBar',
        name: 'Más información sobre créditos generativos',
    },
    {
        id: 15020,
        label: 'Ayuda > Pautas del usuario de la IA generativa de Adobe',
        placement: 'MenuBar',
        name: 'Pautas del usuario de la IA generativa de Adobe',
    },
    {
        id: 15201,
        label: 'Archivo > Buscar Adobe Stock...',
        placement: 'MenuBar',
        name: 'Buscar Adobe Stock...',
    },
    {
        id: 15202,
        label: 'Archivo > Buscar plantillas de Adobe Express...',
        placement: 'MenuBar',
        name: 'Buscar plantillas de Adobe Express...',
    },
    {
        id: 15203,
        label: 'Ayuda > Tutoriales prácticos...',
        placement: 'MenuBar',
        name: 'Tutoriales prácticos...',
    },
    {
        id: 15204,
        label: 'Ayuda > Novedades...',
        placement: 'MenuBar',
        name: 'Novedades...',
    },
    {
        id: 17001,
        label: 'Edición > Deformación de perspectiva',
        placement: 'MenuBar',
        name: 'Deformación de perspectiva',
    },
    {
        id: 20006,
        label: 'Archivo > Historial de versiones',
        placement: 'MenuBar',
        name: 'Historial de versiones',
    },
    {
        id: 20007,
        label: 'Ventana > Historial de versiones',
        placement: 'MenuBar',
        name: 'Historial de versiones',
    },
    {
        id: 20008,
        label: 'Ventana > Comentarios',
        placement: 'MenuBar',
        name: 'Comentarios',
    },
    {
        id: 21000,
        label: 'Capa > Objetos inteligentes > Convertir en capas',
        placement: 'MenuBar',
        name: 'Convertir en capas',
    },
    {
        id: 21001,
        label: 'Vista > Ajustar capa(s) en la pantalla',
        placement: 'MenuBar',
        name: 'Ajustar capa(s) en la pantalla',
    },
    {
        id: 22003,
        label: 'Vista > Guías > Editar guías seleccionadas',
        placement: 'MenuBar',
        name: 'Editar guías seleccionadas',
    },
    {
        id: 22004,
        label: 'Vista > Guías > Borrar guías seleccionadas',
        placement: 'MenuBar',
        name: 'Borrar guías seleccionadas',
    },
    {
        id: 22100,
        label: 'Capa > Enmascarar todos los objetos',
        placement: 'MenuBar',
        name: 'Enmascarar todos los objetos',
    },
    {
        id: 23150,
        label: 'Filtro > Último filtro',
        placement: 'MenuBar',
        name: 'Último filtro',
    },
    {
        id: 23151,
        label: 'Filtro > Último filtro',
        placement: 'MenuBar',
        name: 'Último filtro',
    },
    {
        id: 23152,
        label: 'Filtro > Último filtro',
        placement: 'MenuBar',
        name: 'Último filtro',
    },
    {
        id: 23153,
        label: 'Filtro > Último filtro',
        placement: 'MenuBar',
        name: 'Último filtro',
    },
    {
        id: 25070,
        label: 'Edición > Rotar objeto',
        placement: 'MenuBar',
        name: 'Rotar objeto',
    },
    {
        id: 26010,
        label: 'Edición > Eliminación de reflejos…',
        placement: 'MenuBar',
        name: 'Eliminación de reflejos…',
    },
    {
        id: 30900,
        label: 'Archivo > Colocar imágenes gratuitas de Adobe Stock…',
        placement: 'MenuBar',
        name: 'Colocar imágenes gratuitas de Adobe Stock…',
    },
    {
        id: 'paintbrushTool',
        label: 'Herramienta Pincel',
        placement: 'Tool',
    },
    {
        id: 'adjustmentBrushTool',
        label: 'Herramienta Pincel de ajuste',
        placement: 'Tool',
    },
    {
        id: 'pencilTool',
        label: 'Herramienta Lápiz',
        placement: 'Tool',
    },
    {
        id: 'colorReplacementBrushTool',
        label: 'Herramienta Sustitución de color',
        placement: 'Tool',
    },
    {
        id: 'wetBrushTool',
        label: 'Herramienta Pincel mezclador',
        placement: 'Tool',
    },
    {
        id: 'eraserTool',
        label: 'Herramienta Borrador',
        placement: 'Tool',
    },
    {
        id: 'backgroundEraserTool',
        label: 'Herramienta Borrador de fondos',
        placement: 'Tool',
    },
    {
        id: 'cloneStampTool',
        label: 'Herramienta Sello de clonar',
        placement: 'Tool',
    },
    {
        id: 'patternStampTool',
        label: 'Herramienta Tampón de motivo',
        placement: 'Tool',
    },
    {
        id: 'magicStampTool',
        label: 'Herramienta Pincel corrector',
        placement: 'Tool',
    },
    {
        id: 'historyBrushTool',
        label: 'Herramienta Pincel de historia',
        placement: 'Tool',
    },
    {
        id: 'artBrushTool',
        label: 'Herramienta Pincel histórico',
        placement: 'Tool',
    },
    {
        id: 'smudgeTool',
        label: 'Herramienta Dedo',
        placement: 'Tool',
    },
    {
        id: 'blurTool',
        label: 'Herramienta Desenfocar',
        placement: 'Tool',
    },
    {
        id: 'sharpenTool',
        label: 'Herramienta Enfocar',
        placement: 'Tool',
    },
    {
        id: 'dodgeTool',
        label: 'Herramienta Sobreexponer',
        placement: 'Tool',
    },
    {
        id: 'burnInTool',
        label: 'Herramienta Subexponer',
        placement: 'Tool',
    },
    {
        id: 'saturationTool',
        label: 'Herramienta Esponja',
        placement: 'Tool',
    },
    {
        id: 'redEyeTool',
        label: 'Herramienta Pincel de ojos rojos',
        placement: 'Tool',
    },
    {
        id: 'marqueeRectTool',
        label: 'Herramienta Marco rectangular',
        placement: 'Tool',
    },
    {
        id: 'marqueeEllipTool',
        label: 'Herramienta Marco elíptico',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleRowTool',
        label: 'Herramienta Marco fila única',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleColumnTool',
        label: 'Herramienta Marco columna única',
        placement: 'Tool',
    },
    {
        id: 'moveTool',
        label: 'Herramienta Mover',
        placement: 'Tool',
    },
    {
        id: 'artboardTool',
        label: 'Herramienta Mesa de trabajo',
        placement: 'Tool',
    },
    {
        id: 'lassoTool',
        label: 'Herramienta Lazo',
        placement: 'Tool',
    },
    {
        id: 'selectionBrushTool',
        label: 'Pincel de selección',
        placement: 'Tool',
    },
    {
        id: 'magicLassoTool',
        label: 'Herramienta Selección de objetos',
        placement: 'Tool',
    },
    {
        id: 'polySelTool',
        label: 'Herramienta Lazo poligonal',
        placement: 'Tool',
    },
    {
        id: 'magneticLassoTool',
        label: 'Herramienta Lazo magnético',
        placement: 'Tool',
    },
    {
        id: 'magicWandTool',
        label: 'Herramienta Varita mágica',
        placement: 'Tool',
    },
    {
        id: 'quickSelectTool',
        label: 'Herramienta Selección rápida',
        placement: 'Tool',
    },
    {
        id: 'cropTool',
        label: 'Herramienta Recortar',
        placement: 'Tool',
    },
    {
        id: 'perspectiveCropTool',
        label: 'Herramienta Recorte con perspectiva',
        placement: 'Tool',
    },
    {
        id: 'sliceTool',
        label: 'Herramienta Sector',
        placement: 'Tool',
    },
    {
        id: 'sliceSelectTool',
        label: 'Herramienta Seleccionar sector',
        placement: 'Tool',
    },
    {
        id: 'magicEraserTool',
        label: 'Herramienta Borrador mágico',
        placement: 'Tool',
    },
    {
        id: 'gradientTool',
        label: 'Herramienta Degradado',
        placement: 'Tool',
    },
    {
        id: 'bucketTool',
        label: 'Herramienta Bote de pintura',
        placement: 'Tool',
    },
    {
        id: 'pathComponentSelectTool',
        label: 'Herramienta Selección de trazado',
        placement: 'Tool',
    },
    {
        id: 'directSelectTool',
        label: 'Herramienta Selección directa',
        placement: 'Tool',
    },
    {
        id: 'penTool',
        label: 'Herramienta Pluma',
        placement: 'Tool',
    },
    {
        id: 'freeformPenTool',
        label: 'Herramienta Pluma de forma libre',
        placement: 'Tool',
    },
    {
        id: 'curvaturePenTool',
        label: 'Herramienta Pluma de curvatura',
        placement: 'Tool',
    },
    {
        id: 'addKnotTool',
        label: 'Herramienta Añadir punto de ancla',
        placement: 'Tool',
    },
    {
        id: 'deleteKnotTool',
        label: 'Herramienta Eliminar punto de ancla',
        placement: 'Tool',
    },
    {
        id: 'convertKnotTool',
        label: 'Conv. punto de ancla',
        placement: 'Tool',
    },
    {
        id: 'typeCreateOrEditTool',
        label: 'Herramienta Texto horizontal',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateOrEditTool',
        label: 'Herramienta Texto vertical',
        placement: 'Tool',
    },
    {
        id: 'typeCreateMaskTool',
        label: 'Herramienta Máscara de texto horizontal',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateMaskTool',
        label: 'Herramienta Máscara de texto vertical',
        placement: 'Tool',
    },
    {
        id: 'rectangleTool',
        label: 'Herramienta Rectángulo',
        placement: 'Tool',
    },
    {
        id: 'ellipseTool',
        label: 'Herramienta Elipse',
        placement: 'Tool',
    },
    {
        id: 'triangleTool',
        label: 'Herramienta Triángulo',
        placement: 'Tool',
    },
    {
        id: 'polygonTool',
        label: 'Herramienta Polígono',
        placement: 'Tool',
    },
    {
        id: 'lineTool',
        label: 'Herramienta Línea',
        placement: 'Tool',
    },
    {
        id: 'customShapeTool',
        label: 'Herramienta Forma personalizada',
        placement: 'Tool',
    },
    {
        id: 'StarTool',
        label: 'Herramienta Estrella',
        placement: 'Tool',
    },
    {
        id: 'framedGroupTool',
        label: 'Herramienta Marco',
        placement: 'Tool',
    },
    {
        id: 'eyedropperTool',
        label: 'Herramienta Cuentagotas',
        placement: 'Tool',
    },
    {
        id: 'colorSamplerTool',
        label: 'Herramienta Muestra de color',
        placement: 'Tool',
    },
    {
        id: 'rulerTool',
        label: 'Herramienta Regla',
        placement: 'Tool',
    },
    {
        id: 'textAnnotTool',
        label: 'Herramienta Nota',
        placement: 'Tool',
    },
    {
        id: 'handTool',
        label: 'Herramienta Mano',
        placement: 'Tool',
    },
    {
        id: 'rotateTool',
        label: 'Herramienta Rotar vista',
        placement: 'Tool',
    },
    {
        id: 'zoomTool',
        label: 'Herramienta Zoom',
        placement: 'Tool',
    },
    {
        id: 'patchSelection',
        label: 'Herramienta Parche',
        placement: 'Tool',
    },
    {
        id: 'recomposeSelection',
        label: 'Herramienta Movimiento con detección de contenido',
        placement: 'Tool',
    },
    {
        id: 'spotHealingBrushTool',
        label: 'Herramienta Pincel corrector puntual',
        placement: 'Tool',
    },
    {
        id: 'removeTool',
        label: 'Herramienta Quitar',
        placement: 'Tool',
    },
    {
        id: 'editToolbar',
        label: 'Editar barra de herramientas…',
        placement: 'Tool',
    },
    {
        id: 'countTool',
        label: 'Herramienta Recuento',
        placement: 'Tool',
    },
    {
        id: 'panelid.static.actions',
        label: 'Acciones',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.gradients',
        label: 'Degradados',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.styles',
        label: 'Estilos',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.swatches',
        label: 'Muestras',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.patterns',
        label: 'Motivos',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.histogram',
        label: 'Histograma',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.info',
        label: 'Información',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.paths',
        label: 'Trazados',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.customshapes',
        label: 'Formas',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.toolpresets',
        label: 'Herram. preestabl.',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.picker',
        label: 'Color',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.channels',
        label: 'Canales',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.layers',
        label: 'Capas',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.comps',
        label: 'Composiciones de capas',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.animation',
        label: 'Línea de tiempo',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.clonesource',
        label: 'Origen de clonación',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.measurement',
        label: 'Registro de medidas',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.hdrpreview',
        label: 'Previsualización de HDR',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.history',
        label: 'Historia',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.navigator',
        label: 'Navegador',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharacter',
        label: 'Carácter',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparagraph',
        label: 'Párrafo',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharstyle',
        label: 'Estilos de carácter',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparastyle',
        label: 'Estilos de párrafo',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textglyphspanel',
        label: 'Pictogramas',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.annotation',
        label: 'Notas',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.properties',
        label: 'Propiedades',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cai.uxp/panel',
        label: 'Content Credentials (Beta)',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cclibrariespanel/ccLibrariesPanel',
        label: 'Bibliotecas',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.ccx.comments-webview/ccx-comments-uxp-webview',
        label: 'Comentarios',
        placement: 'Panel',
    },
    {
        id: 'actionId:$dytx;selectorId:context_bar',
        label: 'Barra de contexto : Texto dinámico',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:properties',
        label: 'Panel : Texto dinámico',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:options',
        label: 'Herramienta : Texto dinámico',
        placement: 'Option',
    },
];
